<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="tornaAProgetti()">
						<Translate :path="'dizionario.progetti.PROGETTI'"></Translate> </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="hidden-xs ms-1 me-1">{{ progetto.ID_PROGETTO }}</span>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer ms-1" v-on:click="tornaAProgetti()"> {{ progetto.TITOLO }} </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">
						<Translate :path="'dizionario.base.ELENCO'"></Translate> <Translate :path="'dizionario.attivita.ATTIVITA'"></Translate>
					</span>
					<span v-if="revisioneCorrente" class="badge bg-primary ms-2" style="font-size:0.7rem;">Rev. {{
						revisioneCorrente.PROGRESSIVO }}<span v-if="revisioneCorrente.PROGRESSIVO_PADRE"> (Copia della rev {{ revisioneCorrente.PROGRESSIVO_PADRE }})</span></span>
					<span v-if="progetto.CODICE_PROGETTO" class="badge bg-secondary ms-1" style="font-size:0.7rem;">{{ progetto.CODICE_PROGETTO }}</span>
					<span v-if="revisioneCorrente && revisioneCorrente.FLG_PUBBLICATA == 1" class="badge bg-danger ms-1"
						style="font-size:0.7rem;"><Translate :path="'dizionario.base.CONGELATA'"></Translate></span>
					<span
						v-if="revisioneVisualizzata && revisioneCorrente && revisioneVisualizzata.ID_REVISIONE != revisioneCorrente.ID_REVISIONE"
						class="badge bg-warning text-dark ms-1" style="font-size:0.7rem;">Visualizzi Rev. {{
							revisioneVisualizzata.PROGRESSIVO }}<span v-if="revisioneVisualizzata.PROGRESSIVO_PADRE"> (Copia della rev {{ revisioneVisualizzata.PROGRESSIVO_PADRE }})</span></span>
				</h4>
				<a href="#page_header"
					class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto"
					data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10"
						style="text-align: left;"
						v-if="!isReadOnly && $root.hasFunzionalita('ATTIVITA_CREATE')"
						v-on:click="apriSceltaTipoCreazione()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<Translate :path="'dizionario.base.BTN_ADD'" class="me-1"></Translate>
								<Translate :path="'dizionario.base.BTN_NUOVO'"></Translate>
							</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.attivita.ATTIVITA'"></Translate></div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a v-if="$root.hasFunzionalita('CONF_ATTIVITA_READ')" href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill"
							v-on:click="$root.confTravelTipologiche(11)" title="Opzioni Progetti"
							data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2"
							v-on:click="$root.confTravelLingue(11)" title="Definizioni Lingua" data-bs-toggle="tooltip"
							data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2"
							v-on:click="$root.help(11)" title="Help OnLine" data-bs-toggle="tooltip"
							data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer"
							data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1"
							v-on:click="openOffCanvas(); openSchedaVisualizzazioneProgetto()">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1"><Translate :path="'dizionario.progetti.PROGETTI'"></Translate></span>
								<span class="hidden-xs ms-1">
									<Translate :path="'dizionario.progetti.SCHEDA_PROGETTO'" class="me-1"></Translate>
								</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a href="#activities-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded"
							data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list-checks"></i>
								<span class="hidden-lg ms-1"><Translate :path="'dizionario.attivita.ATTIVITA'"></Translate></span>
								<span class="hidden-xs ms-1">
									<Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate><Translate :path="'dizionario.attivita.ATTIVITA'"></Translate>
								</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav"
							class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed"
							data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>



				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item ms-lg-1">
							<a v-if="revisioneCorrente && revisioneCorrente.FLG_PUBBLICATA == 0 && canEditProgetto && !bloccato"
								href="#"
								@click.prevent="creaRevisione()"
								class="navbar-nav-link rounded"
								title="Crea nuova revisione"
							>
								<i class="ph-git-branch me-2"></i>
								<span class="d-none d-lg-inline"><Translate :path="'dizionario.attivita.NUOVA_REVISIONE'"></Translate></span>
							</a>
						</li>
						<li class="nav-item ms-lg-3">
							<a href="#"
								@click.prevent="filters.openPopUp('popUpStorico')"
								class="navbar-nav-link rounded"
								title="Visualizza storico revisioni"
							>
								<i class="ph-clock-counter-clockwise me-2"></i>
								<span class="d-none d-lg-inline"><Translate :path="'dizionario.attivita.STORICO_REVISIONI'"></Translate></span>
							</a>
						</li>
						<li class="nav-item dropdown ms-lg-3">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle"
									data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;"><Translate :path="'dizionario.base.AZIONI_MULTIPLE'"></Translate></span>
								</a>
								<div class="dropdown-menu dropdown-menu-end" style="">
									<div class="dropdown-submenu dropdown-submenu-start" v-if="canEditAttivita && !isReadOnly">
										<a href="#" class="dropdown-item"><i
												class="fad fa-ballot-check fa-fw me-2"></i><span
												class="text-muted me-1">|</span><Translate :path="'dizionario.base.STATO'"></Translate></a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="attivaSelezionati()"><i
													class="far fa-check-square fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.ATTIVA_SELEZIONATI'"></Translate></a>
											<a href="#" class="dropdown-item" @click.prevent="disattivaSelezionati()"><i
													class="far fa-square fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.DISATTIVA_SELEZIONATI'"></Translate></a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start" v-if="canEditAttivita && !isReadOnly">
										<a href="#" class="dropdown-item"><i
												class="far fa-exchange fa-fw me-2"></i><span
												class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.CONSUNTIVO'"></Translate></a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="consuntivoSelezionati(1)"><i
													class="far fa-arrow-right fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.SPOSTA_CONSUNTIVO'"></Translate></a>
											<a href="#" class="dropdown-item" @click.prevent="consuntivoSelezionati(0)"><i
													class="far fa-arrow-left fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.RIPORTA_PREVENTIVO'"></Translate></a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i
												class="fad fa-file-export fa-fw me-2"></i><span
												class="text-muted me-1">|</span><Translate :path="'dizionario.base.COMUNICAZIONI'"></Translate></a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.INVIA_EMAIL'"></Translate></a>
											<a href="#" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.INVIA_SMS'"></Translate></a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="fad fa-print fa-fw me-2"></i><span
												class="text-muted me-1">|</span><Translate :path="'dizionario.base.STAMPE'"></Translate></a>
										<div class="dropdown-menu">
											<a v-if="canExportAttivita" v-on:click="apriModalitaEsportazione()" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.base.ESPORTA_EXCEL'"></Translate></a>
											<div class="dropdown-divider" v-if="canImportAttivita"></div>
											<a v-if="canImportAttivita" v-on:click="apriImportaExcelOffline()" class="dropdown-item"><i
													class="ph-upload-simple fa-fw me-2 text-success"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.IMPORTA_EXCEL_OFFLINE'"></Translate></a>
											<!-- <a v-on:click="stampeOrdine(1010)" class="dropdown-item"><i
													class="far fa-file-excel fa-fw me-2"></i><span
													class="text-muted me-1">|</span>Genera Excel</a> -->
											<a v-if="canExportAttivita" v-on:click="esportaBudgetPdf()" class="dropdown-item"><i
													class="far fa-file-pdf fa-fw me-2"></i><span
													class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.STAMPA_BUDGET'"></Translate></a>
										</div>
									</div>
									<div class="dropdown-divider" v-if="canDeleteAttivita && !isReadOnly"></div>
									<a href="#" class="dropdown-item" v-if="canDeleteAttivita && !isReadOnly" @click.prevent="eliminaSelezionati()"><i
											class="fad fa-trash fa-fw me-2 text-danger"></i><span
											class="text-muted me-1">|</span><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate></a>
									<a href="#" class="dropdown-item" v-if="$root.isGod && !isReadOnly && eliminatiSelezionati" @click.prevent="ripristinaSelezionati()"><i
											class="fad fa-redo fa-fw me-2 text-success"></i><span
											class="text-muted me-1">|</span>Ripristina selezionati</a>
								</div>
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->

	</div>
	<!-- /page header -->

	<!-- Content area -->
	<div class="content content-1 table-cms-wrapper">
		<div v-if="bloccato" class="alert alert-warning py-2 mb-2"><i class="ph-lock me-1"></i>Budget in modifica da <b>{{ lock.USERNAME }}</b> — sola lettura</div>
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="progetti-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1" v-show="!editMode">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse"
								role="button" aria-expanded="false">
								<Translate :path="'dizionario.base.MOSTRA_FILTRI'"></Translate>
							</a>
						</div>
					</div>

					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all">
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="progetto-a">
									<div class="row">
										<!-- Filtri (nascosti quando editMode = true) -->
										<div v-if="!editMode" class="col-12">
											<div class="row">
												<div class="col-5 col-md-1 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="'Id ' + $root.translate('dizionario.attivita.ATTIVITA')" :tabindex="1"
														v-model="search.ID_ATTIVITA.VALUE" />
												</div>
												<div class="col-7 col-md-1 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="'Id ' + $root.translate('dizionario.attivita.VOCE')" :tabindex="2" v-model="search.ID_VOCE.VALUE" />
												</div>
												<div class="col-12 col-md-2 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="$root.translate('dizionario.attivita.ATTIVITA')" :tabindex="4" v-model="search.TITOLO.VALUE" />
												</div>
												<div class="col-12 col-md-2 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="$root.translate('dizionario.attivita.VOCE')" :tabindex="4" v-model="search.TITOLO_VOCE.VALUE" />
												</div>
												<div class="col-12 col-md-1 mbx-1">
													<select class="form-control form-control-sm" :tabindex="5"
														v-model="search.FLG_DA_CALCOLARE.VALUE">
														<option value="">{{ $root.translate('dizionario.attivita.CALCOLO') }}</option>
														<option value="1">{{ $root.translate('dizionario.base.SI') }}</option>
														<option value="0">{{ $root.translate('dizionario.base.NO') }}</option>
													</select>
												</div>
												<div class="col-12 col-md-1 mbx-1" v-if="$root.isGod">
													<select class="form-control form-control-sm" v-model="search.FLG_ELIMINATO.VALUE">
														<option value="0">{{ $root.translate('dizionario.attivita.NON_ELIMINATE') }}</option>
														<option value="">{{ $root.translate('dizionario.base.TUTTE') }}</option>
														<option value="1">{{ $root.translate('dizionario.attivita.ELIMINATE') }}</option>
													</select>
												</div>
												<div class="col-12 col-md-2 mbx-1">
													<Select2 v-model="filtroFornitore" :api="'theb-s2/fornitori'" :apiselected="'theb-s2/fornitori/selected'"
														:opzioniIniziali="fornitoriProgetto" :placeholder="$root.translate('dizionario.base.FORNITORE')"></Select2>
												</div>
												<div v-if="!isReadOnly" class="col-12 col-md mbx-1 d-flex justify-content-end align-items-center">
													<button
														@click="editMode = true"
														class="btn btn-primary btn-sm"
														title="Abilita riordino (disabilita filtri)"
													>
														<i class="ph-arrows-out-cardinal me-1"></i>
														<span class="d-none d-lg-inline"><Translate :path="'dizionario.attivita.ABILITA_RIORDINO'"></Translate></span>
													</button>
												</div>
											</div>
										</div>

										<!-- Pulsanti riordino (visibili quando editMode = true) -->
										<div v-if="editMode && !isReadOnly" class="col-12">
											<div class="d-flex gap-2 align-items-center p-2" style="background-color: #f0f7ff; border-radius: 4px;">
												<span class="text-warning fw-semibold flex-grow-1">
													<i class="ph-warning me-1"></i>
													Modalità riordino attiva - i filtri sono disabilitati
												</span>
												<button
													@click="disabilitaRiordino"
													class="btn btn-secondary btn-sm"
													title="Disabilita riordino (riabilita filtri)"
												>
													<i class="ph-x me-1"></i>
													<span class="d-none d-lg-inline"><Translate :path="'dizionario.attivita.ANNULLA_RIORDINO'"></Translate></span>
												</button>
												<button
													@click="salvaOrdinamento"
													:disabled="!hasUnsavedChanges || saving"
													class="btn btn-success btn-sm"
													:class="{ 'pulse': hasUnsavedChanges }"
													title="Salva ordinamento attività e voci"
												>
													<i class="ph-floppy-disk me-1"></i>
													<span class="d-none d-lg-inline">{{ saving ? 'Salvataggio...' : $root.translate('dizionario.attivita.SALVA_ORDINAMENTO') }}</span>
													<span v-if="hasUnsavedChanges" class="badge bg-warning ms-1 d-none d-lg-inline">!</span>
												</button>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead" style="min-height: 200px; max-height: calc(100vh - 390px);">
							<table class="table table-togglable table-bordered" style="table-layout: fixed;">
								<colgroup>
									<col style="width: 3%;">
									<col style="width: 35%;">
									<col style="width: 3%;">
									<col style="width: 4%;">
									<col style="width: 6%;">
									<col style="width: 14%;">
									<col style="width: 6%;">
									<col style="width: 6%;">
									<col style="width: 6%;">
									<col style="width: 11%;">
									<col style="width: 5%;">
								</colgroup>
								<thead v-if="!$root.isMobile" class="sticky-top thead-bordered">
									<tr class="text-white">
										<th class="table-head-sm text-center bg-secondary" style="width:3%;" rowspan="2">
											<div class="d-flex align-items-center">
												<input v-if="!isReadOnly" type="checkbox" class="me-1" v-model="tuttiSelezionati" @change="filters.selectTree(nodiSelezionabili, tuttiSelezionati ? 1 : 0)" :title="$root.translate('dizionario.progetti.SELEZIONA_TUTTI')" />
												<i class="cursor-pointer text-white" :class="allExpanded ? 'ph-caret-down' : 'ph-caret-right'" @click="allExpanded = !allExpanded" title="Espandi/Chiudi tutte"></i>
											</div>
										</th>
										<th class="table-head-sm text-center bg-secondary" style="width:35%;" rowspan="2">
											<Translate :path="'dizionario.base.TITOLO'"></Translate>
										</th>
										<th class="table-head-sm text-center bg-secondary" style="width:26%; border-right: 20px solid white !important;" colspan="4"><Translate :path="'dizionario.attivita.VENDITA'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:35%; border-left: 20px solid white !important;" colspan="4"><Translate :path="'dizionario.attivita.ACQUISTO'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:5%;" rowspan="2"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
									</tr>
									<tr class="text-white">
										<th class="table-head-sm text-center bg-secondary" style="width:3%; border-left: 1px solid white; border-right: 1px solid white;"><Translate :path="'dizionario.attivita.QUANTITA'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:4%; border-left: 1px solid white; border-right: 1px solid white;"><Translate :path="'dizionario.attivita.GIORNI'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:6%; border-left: 1px solid white; border-right: 1px solid white;"><Translate :path="'dizionario.attivita.PREZZO_UNIT'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary" style="width:14%; border-left: 1px solid white; border-right: 20px solid white !important;"><Translate :path="'dizionario.attivita.TOTALE'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:6%; border-left: 20px solid white !important; border-right: 1px solid #FFD648;"><Translate :path="'dizionario.attivita.COSTO_UNIT'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:6%; border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;"><Translate :path="'dizionario.attivita.COSTI'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:6%; border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></th>
										<th class="table-head-sm text-center bg-secondary text-yellow" style="width:11%; border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;"><Translate :path="'dizionario.base.FORNITORE'"></Translate></th>
									</tr>
								</thead>
								<tbody>
									<!-- Static empty placeholder (only visible when no attività and in editMode) -->
									<tr v-if="(!attivitaList || attivitaList.length == 0) && editMode">
										<td colspan="11" class="p-3">
											<div class="empty-attivita-placeholder">
												<span><Translate :path="'dizionario.attivita.TRASCINA_ATTIVITA_QUI'"></Translate></span>
											</div>
										</td>
									</tr>
									<tr>
										<td class="p-0 m-0" colspan="11">
											<draggable
												:key="`root-drag-${editMode}`"
												tag="div"
												:list="attivitaList"
												handle=".drag-handle-attivita"
												:disabled="!editMode"
												group="attivita"
												:animation="200"
												ghostClass="sortable-ghost"
												chosenClass="sortable-chosen"
												dragClass="sortable-drag"
												itemKey="ID_ATTIVITA"
												:fallbackOnBody="true"
												:removeCloneOnHide="true"
												@start="onRootAttivitaDragStart"
												@end="onRootAttivitaDragEnd"
												@change="onRootAttivitaChange"
												:move="onRootAttivitaMove"
												class="root-attivita-container"
												:class="{ 'root-attivita-empty': (!attivitaList || attivitaList.length == 0) && draggingRootAttivita }"
											>
												<!-- Placeholder quando vuoto e in drag -->
												<div v-if="(!attivitaList || attivitaList.length == 0) && draggingRootAttivita" class="root-drop-placeholder">
													<span><Translate :path="'dizionario.attivita.TRASCINA_ROOT'"></Translate></span>
												</div>

												<AttivitaNode
													v-for="attivita in attivitaList"
													:key="attivita.ID_ATTIVITA"
													:attivita="attivita"
													:depth="0"
													:progetto="progetto"
													:force-expanded="allExpanded"
													:read-only="isReadOnly"
													:drag-enabled="editMode && !isReadOnly"
													:dragging-attivita-from-parent="draggingRootAttivita"
													:show-iva="showIva"
													@refresh="getAttivita"
													@mark-unsaved-changes="hasUnsavedChanges = true"
													@apri-azioni="apriAzioni"
													@apri-azioni-voce="apriAzioniVoce"
													@crea-voce="creaVoce"
													@modifica-voce="modificaVoce"
													@elimina-voce="eliminaVoce"
												/>
											</draggable>
											<!-- In coda al preventivo e al consuntivo (fuori dal drag): sconti, e i totali se l'utente li vuole nell'albero.
												 Il consuntivo e' un nodo virtuale: a/da consuntivo si passa solo dal menu -->
											<template v-for="sez in sezioniAlbero" :key="sez.KEY">
												<AttivitaNode
													v-if="sez.NODO"
													:class="{ 'mt-3': totaliInAlbero }"
													:attivita="sez.NODO"
													:depth="0"
													:progetto="progetto"
													:force-expanded="allExpanded"
													:read-only="isReadOnly"
													:drag-enabled="false"
													:show-iva="showIva"
													@refresh="getAttivita"
													@apri-azioni="apriAzioni"
													@apri-azioni-voce="apriAzioniVoce"
												/>
												<table v-if="sez.RIGHE.length" class="table table-bordered table-sm mb-0" :class="{ 'mt-3': totaliInAlbero }" style="table-layout: fixed; width: 100%;">
												<colgroup>
													<col style="width: 3%;">
													<col style="width: 35%;">
													<col style="width: 3%;">
													<col style="width: 4%;">
													<col style="width: 6%;">
													<col style="width: 14%;">
													<col style="width: 6%;">
													<col style="width: 6%;">
													<col style="width: 6%;">
													<col style="width: 11%;">
													<col style="width: 5%;">
												</colgroup>
												<tbody>
														<tr v-for="(riga, i) in sez.RIGHE" :key="sez.KEY + '-' + i" :class="{ 'cursor-pointer': riga.CLICK }"
															@click="riga.CLICK && riga.CLICK()">
															<template v-if="!$root.isMobile">
																<!-- totali nell'albero: senza la colonna di sinistra -->
																<td v-if="!totaliInAlbero"></td>
																<td class="p-1" :class="riga.CLASSE" :colspan="totaliInAlbero ? 5 : 4"><input v-if="riga.REF && riga.CLICK" type="checkbox" class="me-2" :checked="riga.REF.SELEZIONATO == 1" @click.stop @change="filters.selectTree([riga.REF], $event.target.checked ? 1 : 0)"><i v-if="riga.ICONA" :class="riga.ICONA" class="me-1"></i>{{ riga.LABEL }}</td>
																<!-- stesso stacco bianco vendita/acquisto di VoceNode -->
																<td class="p-1 text-end" :class="riga.CLASSE" style="border-right: 20px solid white !important;"><template v-if="!riga.VUOTA">{{ riga.NEGATIVO ? '- ' : '' }}&euro; {{ filters.formattaImporto(riga.VALORE) }}</template></td>
																<!-- lato acquisto: acquisto, commissioni, margine e utile sulle ultime 4 righe del preventivo -->
																	<template v-if="riga.ACQ">
																		<td colspan="2" class="p-1" :class="riga.ACQ.CLASSE" style="border-left: 20px solid white !important;">{{ riga.ACQ.LABEL }}</td>
																		<td colspan="2" class="p-1 text-end" :class="riga.ACQ.CLASSE" :title="riga.ACQ.TITLE">{{ riga.ACQ.PCT != null ? riga.ACQ.PCT + '%' : '€ ' + filters.formattaImporto(riga.ACQ.VALORE) }}</td>
																		<td :class="{ 'cella-senza-bordo': totaliInAlbero }"></td>
																	</template>
																	<td v-else colspan="5" :class="{ 'cella-senza-bordo': totaliInAlbero }" style="border-left: 20px solid white !important;"></td>
															</template>
															<td v-else colspan="11" class="p-1" :class="riga.CLASSE">
																<i v-if="riga.ICONA" :class="riga.ICONA" class="me-1"></i>{{ riga.LABEL }}<span v-if="!riga.VUOTA" class="float-end">{{ riga.NEGATIVO ? '- ' : '' }}&euro; {{ filters.formattaImporto(riga.VALORE) }}</span>
																	<div v-if="riga.ACQ" class="mt-1 p-1" :class="riga.ACQ.CLASSE">{{ riga.ACQ.LABEL }}<span class="float-end">{{ riga.ACQ.PCT != null ? riga.ACQ.PCT + '%' : '€ ' + filters.formattaImporto(riga.ACQ.VALORE) }}</span></div>
														</td>
													</tr>
												</tbody>
											</table>
											</template>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="row page-bottom mt-2">
							<div v-if="!editMode" class="col-9 col-md-11" :tabindex="27">
								<div class="float-end pag-mobile">
									<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
										:numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
								</div>
							</div>
							<div v-else class="col-9 col-md-11" :tabindex="27">
								<div class="float-end text-warning">
									<i class="ph-warning me-1"></i>
									<small>Modalità riordino attiva - Filtri disabilitati</small>
								</div>
							</div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end"
									data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE"
									style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
									<option value="5">5</option>
									<option value="10">10</option>
									<option value="25">25</option>
									<option value="50">50</option>
									<option value="75">75</option>
									<option value="100">100</option>
									<option value="250">250</option>
									<option value="500">500</option>
								</select>
							</div>
						</div>

					</div>
				</div>

				<NoteSpeseProg v-if="!isStorico" :arrayNoteSpese="arrayNoteSpese" @apri-azioni="apriAzioniSpesa" />

				<div class="row mb-3 mt-2">
					<div class="col-12">
						<div style="position: relative; top: 10px; white-space: nowrap; overflow-x: auto;">
							<!-- Con i totali nell'albero qui resta solo il bottone IVA -->
							<template v-if="!totaliInAlbero">
							<span class="fw-semibold me-2"><Translate :path="'dizionario.attivita.BUDGET'"></Translate>:</span>
							<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2">
								<Translate :path="'dizionario.attivita.TOTALE_PARZIALE'"></Translate>: &euro; {{ showIva && getTotali.TOTALE_IVA > 0 ? filters.formattaImporto(getTotali.TOTALE_CON_IVA) : filters.formattaImporto(getTotali.BUDGET) }}
							</span>
							<span class="badge bg-info bg-opacity-20 text-info rounded-0 p-2 me-2"
								:title="'Fee progetto ' + (progetto.FEE || 0) + '% sul budget'"
								data-bs-toggle="tooltip" data-bs-placement="top">
								<Translate :path="'dizionario.attivita.FEE_AGENZIA'"></Translate>: &euro; {{ getTotali.FEE }}
							</span>
							<span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2 me-2">
								<Translate :path="'dizionario.attivita.TOTALE_IMPONIBILE'"></Translate>: &euro; {{ showIva && getTotali.TOTALE_IVA > 0 ? filters.formattaImporto(getTotali.TOTALE_CON_IVA) : filters.formattaImporto(getTotali.GRAND_TOTAL) }}
							</span>
							<template v-if="getTotali.SCONTO > 0">
								<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2"
									:class="{ 'cursor-pointer': $root.hasFunzionalita('PROGETTO_UPDATE') && !bloccato }"
									@click="$root.hasFunzionalita('PROGETTO_UPDATE') && !bloccato && apriSconti()">
									<Translate :path="'dizionario.attivita.SCONTO'"></Translate>: - &euro; {{ filters.formattaImporto(getTotali.SCONTO) }}
								</span>
								<span class="badge bg-primary rounded-0 p-2 me-2">
									<Translate :path="'dizionario.attivita.TOTALE_GENERALE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.TOTALE_GENERALE) }}
								</span>
							</template>
							<span
								class="badge bg-danger bg-opacity-20 text-danger rounded-0 p-2 me-2"
								:title="getPct(getTotali.COSTO_ESPOSTO)"
								data-bs-toggle="tooltip" data-bs-placement="top">
								<Translate :path="'dizionario.attivita.ACQUISTO'"></Translate>: &euro; {{ showIva && getTotali.TOTALE_IVA_COSTO > 0 ? filters.formattaImporto(getTotali.TOTALE_CON_IVA_COSTO) : filters.formattaImporto(getTotali.COSTO_ESPOSTO) }}
							</span>
							<span
								class="badge bg-warning bg-opacity-20 text-warning rounded-0 p-2 me-2"
								:title="getPct(getTotali.COSTO_PRIVATO)"
								data-bs-toggle="tooltip" data-bs-placement="top">
								<Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate>: &euro; {{ showIva && getTotali.TOTALE_IVA_COMMISSIONI > 0 ? filters.formattaImporto(getTotali.TOTALE_CON_IVA_COMMISSIONI) : filters.formattaImporto(getTotali.COSTO_PRIVATO) }}
							</span>
							<span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2 me-2">
								<Translate :path="'dizionario.attivita.MARGINE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.MARGINE) }}
							</span>
							<span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2 me-2">
								<Translate :path="'dizionario.attivita.UTILE'"></Translate>: {{ getMarginePercentage() }}%
							</span>
							</template>
							<button v-if="getTotali.TOTALE_IVA > 0 || getTotali.TOTALE_IVA_COSTO > 0 || getTotali.TOTALE_IVA_COMMISSIONI > 0"
								class="btn btn-sm ms-2"
								:class="showIva ? 'btn-success' : 'btn-secondary'"
								@click="showIva = !showIva"
								style="cursor: pointer; user-select: none;"
								title="Mostra/nascondi valori IVA inclusa"
								data-bs-toggle="tooltip" data-bs-placement="top">
								{{ $root.translate(showIva ? 'dizionario.attivita.NASCONDI_IVA' : 'dizionario.attivita.MOSTRA_IVA') }}
							</button>
						</div>
					</div>
				</div>

				<!-- Totali del consuntivo: extra + storni, chiude col totale finale dell'evento (IVA esclusa) -->
				<div v-if="nodoConsuntivo && !totaliInAlbero" class="row mt-2">
					<div class="col-12">
						<div style="position: relative; top: 10px; white-space: nowrap; overflow-x: auto;">
							<span class="fw-semibold me-2"><Translate :path="'dizionario.attivita.CONSUNTIVO'"></Translate>:</span>
							<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2">
								<Translate :path="'dizionario.attivita.TOTALE_PARZIALE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.CONS_BUDGET) }}
							</span>
							<span class="badge bg-info bg-opacity-20 text-info rounded-0 p-2 me-2">
								<Translate :path="'dizionario.attivita.FEE_AGENZIA'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.CONS_FEE) }}
							</span>
							<span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2 me-2">
								<Translate :path="'dizionario.attivita.TOTALE_IMPONIBILE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.CONS_IMPONIBILE) }}
							</span>
							<template v-if="getTotali.STORNI != 0">
								<span class="badge bg-danger bg-opacity-20 text-danger rounded-0 p-2 me-2" :class="{ 'cursor-pointer': !bloccato }" @click="!bloccato && apriStorni()">
									<Translate :path="'dizionario.attivita.STORNI'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.STORNI) }}
								</span>
								<span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2 me-2">
									<Translate :path="'dizionario.attivita.TOTALE_IMPONIBILE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.CONS_IMPONIBILE_2) }}
								</span>
							</template>
							<span class="badge bg-primary rounded-0 p-2 me-2" :title="$root.translate('dizionario.attivita.TOTALE_FINALE_INFO')">
								<Translate :path="'dizionario.attivita.TOTALE_FINALE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.TOTALE_FINALE) }}
							</span>
						</div>
					</div>
				</div>

			</div>

		</div>
	</div>




	<!-- START MODALI -->
	<div class="offcanvas offcanvas-end offcanvas-size-xlg" id="panel_right" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-info text-white border-0" style="height: 3.95rem;">
			<h5 class="modal-title modal-title-width">
				<i class="ph-list icon-modal-size me-2"></i>Scheda Informativa
			</h5>
			<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="offcanvas">
				<i class="ph-x icon-x-size"></i>
			</button>
		</div>
		<div class="offcanvas-body p-2">

			<SchedaVisualizzazioneProgetto :ref="'schedaVisualizzazioneProgetto'" @modificaProgetto="modificaProgetto($event)"></SchedaVisualizzazioneProgetto>

		</div>
		<div class="border-top p-1 bg-light">
			<button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">
				<i class="fal fa-sign-out-alt fa-fw me-2"></i>
				<Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
			</button>
		</div>
	</div>
	

	<SchedaProgetto :ref="'schedaProgetto'" :statiProgetto="arrayStatiProgetto"></SchedaProgetto>

	<div class="modal fade" id="popUpAttivita" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0 py-2">
					<h6 class="modal-title mb-0">
						<i class="ph-list me-2"></i>
						<span class="ms-1 me-1">{{ $root.translate(attivitaSelezionata.ID_ATTIVITA > 0 ? 'dizionario.base.BTN_MODIFICA' : 'dizionario.base.BTN_NUOVA') }}</span><Translate :path="'dizionario.attivita.ATTIVITA'"></Translate> - <small class="text-white-50">{{ filters.titoloConTipologia(progetto) }}</small>
					</h6>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
						data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-3">

					<div class="mb-2">
						<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.TITOLO_ATTIVITA'"></Translate> <span class="text-danger">*</span></label>
						<input type="text" class="form-control form-control-sm" v-model="attivitaSelezionata.TITOLO"
							placeholder="Inserisci il titolo dell'attività" @keyup.enter="salvaAttivita(false)">
					</div>

					<div class="row mb-2">
						<div class="col-12 col-md-6">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.ATTIVITA_PADRE'"></Translate></label>
							<select class="form-select form-select-sm" v-model="attivitaSelezionata.FK_ID_ATTIVITA">
								<option :value="null">{{ $root.translate('dizionario.attivita.NESSUNA_RADICE') }}</option>
								<option v-for="att in attivitaFlat" :key="att.ID_ATTIVITA" :value="att.ID_ATTIVITA"
									:disabled="att.ID_ATTIVITA == attivitaSelezionata.ID_ATTIVITA || idDiscendentiSelezionata.includes(att.ID_ATTIVITA)">{{ att.TITOLO }}
								</option>
							</select>
						</div>
						<div class="col-12 col-md-6">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.CITTA'"></Translate></label>
							<Select2 v-model="attivitaSelezionata.FK_ID_CITTA" :w="250" :api="'core/geo/comuni/select2'"
								:apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'">
							</Select2>
						</div>
					</div>

					<div class="mb-2">
						<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.DESCRIZIONE'"></Translate></label>
						<textarea class="form-control form-control-sm" v-model="attivitaSelezionata.DESCRIZIONE" rows="2"
							placeholder="Descrizione opzionale dell'attività"></textarea>
					</div>

					<div class="row mb-2 align-items-end">
						<div class="col-12 col-md-8">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.COLORE'"></Translate></label>
							<ColorPicker v-model="attivitaSelezionata.COLORE"></ColorPicker>
						</div>
						<div class="col-12 col-md-4 mt-2 mt-md-0">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.INCLUDI_CALCOLO'"></Translate></label>
							<div>
								<ISwitch v-model="attivitaSelezionata.FLG_DA_CALCOLARE" style="z-index:0;"></ISwitch>
							</div>
						</div>
					</div>

					<div class="row mb-2 align-items-end">
						<div class="col-12 col-md-8">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.COLORE_TESTO'"></Translate></label>
							<div class="d-flex align-items-center gap-2">
								<div class="form-check form-switch mb-0">
									<input type="checkbox" class="form-check-input" v-model="coloreTestoAutomaticoAttivita">
									<label class="form-check-label small"><Translate :path="'dizionario.attivita.COLORE_TESTO_AUTOMATICO'"></Translate></label>
								</div>
								<ColorPicker v-model="attivitaSelezionata.COLORE_TESTO" :disabled="coloreTestoAutomaticoAttivita"></ColorPicker>
							</div>
						</div>
					</div>
				</div>


				<div class="modal-footer py-2">
					<button type="button" class="btn btn-sm btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i>
						<Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
					<button v-if="attivitaSelezionata.ID_ATTIVITA == 0 ? canCreateAttivita : canEditAttivita" type="button" class="btn btn-sm btn-secondary" @click="salvaAttivita(false)"
						:disabled="!attivitaSelezionata.TITOLO">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CHIUDI'"></Translate>
					</button>
					<button v-if="attivitaSelezionata.ID_ATTIVITA == 0 && canCreateAttivita" type="button" class="btn btn-sm btn-primary" @click="salvaAttivita(true)"
						:disabled="!attivitaSelezionata.TITOLO">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CONTINUA'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div>


	<!-- Modal Nuova/Modifica Voce -->
	<div class="modal fade" id="popUpVoce" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0 py-2">
					<h6 class="modal-title mb-0">
						<i class="ph-plus-circle me-2"></i>
						{{ $root.translate(voceSelezionata.ID_VOCE > 0 ? 'dizionario.base.BTN_MODIFICA' : 'dizionario.base.BTN_NUOVA') }} <Translate :path="'dizionario.attivita.VOCE'"></Translate> - <small class="text-white-50">{{ attivitaPerVoce.TITOLO }}</small>
					</h6>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-3">
					<div class="row mb-2">
						<div class="col-12 col-md-6">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.TITOLO'"></Translate> <span class="text-danger">*</span></label>
							<ckeditor :editor="editor" v-model="voceSelezionata.TITOLO_VOCE" :config="editorConfig"></ckeditor>
						</div>
						<div class="col-12 col-md-6">
							<div class="mb-2">
								<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.NOTE'"></Translate></label>
								<input type="text" class="form-control form-control-sm" v-model="voceSelezionata.NOTE"
									placeholder="Inserisci eventuali note">
							</div>
							<div class="mb-2">
								<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.CLIENTE'"></Translate></label>
								<input type="text" class="form-control form-control-sm bg-light" :value="progetto.CLIENTE || 'N/A'" readonly>
							</div>
							<div>
								<label class="form-label fw-semibold mb-1" style="width:100%;"><Translate :path="'dizionario.base.FORNITORE'"></Translate>
									<span class="badge bg-success badge-xs cursor-pointer float-end" @click="apriNuovoFornitore" title="Crea nuovo fornitore">{{ $root.translate('dizionario.base.BTN_NUOVA') }}</span>
								</label>
								<Select2 v-model="voceSelezionata.FK_ID_AZIENDA_FORNITORE" :api="'theb-s2/fornitori'"
									:apiselected="'theb-s2/fornitori/selected'" msg-inattivo="Fornitore non attivo, attivalo prima di procedere"
									show-toggle @toggle-attivo="toggleFornitore"></Select2>
							</div>
						</div>
					</div>

					<div class="row mb-2 align-items-end">
						<div class="col-12 col-md-8">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.COLORE'"></Translate></label>
							<ColorPicker v-model="voceSelezionata.COLORE"></ColorPicker>
						</div>
						<div class="col-12 col-md-4 d-flex align-items-center gap-2 mt-2 mt-md-0">
							<label class="form-label fw-semibold mb-0 me-2"><Translate :path="'dizionario.attivita.INCLUDI_CALCOLO'"></Translate></label>
							<ISwitch v-model="voceSelezionata.FLG_DA_CALCOLARE" style="z-index:0;"></ISwitch>
						</div>
					</div>

					<div class="row mb-2 align-items-end">
						<div class="col-12 col-md-8">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.COLORE_TESTO'"></Translate></label>
							<div class="d-flex align-items-center gap-2">
								<div class="form-check form-switch mb-0">
									<input type="checkbox" class="form-check-input" v-model="coloreTestoAutomaticoVoce">
									<label class="form-check-label small"><Translate :path="'dizionario.attivita.COLORE_TESTO_AUTOMATICO'"></Translate></label>
								</div>
								<ColorPicker v-model="voceSelezionata.COLORE_TESTO" :disabled="coloreTestoAutomaticoVoce"></ColorPicker>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-primary mb-1 mt-2"><i class="ph-currency-circle-dollar me-1"></i><Translate :path="'dizionario.attivita.VENDITA'"></Translate></h6>
					<div class="row mb-2">
						<div class="col-6 col-md-1">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.QTA'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="voceSelezionata.QUANTITY_PRICE" placeholder="1"
								@input="calcolaTotalePrezzo()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-md-1">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.RIP'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="voceSelezionata.DAYS_PRICE" placeholder="1"
								@input="calcolaTotalePrezzo()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-costo-voce">
							<label class="form-label fw-semibold mb-1 text-nowrap" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COSTO'"></Translate>
								<i class="ph-gift cursor-pointer float-end" :class="voceSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? 'text-success' : 'text-muted'" @click="toggleOmaggio('UNIT_PRICE')" :title="voceSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? 'Omaggio attivo: clicca per disattivare' : 'Clicca per impostare come omaggio'"></i>
							</label>
							<div class="position-relative">
								<input type="number" step="0.01" class="form-control form-control-sm" v-model.number="voceSelezionata.UNIT_PRICE"
									placeholder="0.00"
									:disabled="voceSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1"
									@input="calcolaTotalePrezzo()"
									@blur="voceSelezionata.UNIT_PRICE = parseFloat(voceSelezionata.UNIT_PRICE || 0).toFixed(2)">
							</div>
						</div>
						<div class="col-6 col-iva-voce">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA'"></Translate></label>
							<select class="form-select form-select-sm" v-model="voceSelezionata.FK_ID_IVA_PREZZO" :disabled="voceSelezionata.FLG_NETTO_IVA_VENDITA == 1">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in filters.getCodiciIvaAttivi()"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md-1">
							<label class="form-label mb-1 text-nowrap" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA'"></Translate> ({{ ivaModaleSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaModaleSommario.importo" disabled>
						</div>
						<div class="col-6 col-md-2">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="voceSelezionata.FLG_NETTO_IVA_VENDITA == 1 ? 'dizionario.attivita.TOTALE' : 'dizionario.attivita.TOTALE_CON_IVA'"></Translate></label>
							<div class="position-relative">
								<input type="text" class="form-control form-control-sm bg-light text-primary fw-bold"
									:value="voceSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? $root.translate('dizionario.attivita.OMAGGIO') : ivaModaleSommario.totale" readonly>
							</div>
						</div>
						<div class="col-12 col-md">
							<label class="form-label mb-1 d-none d-md-block invisible" style="font-size:0.85rem;">&nbsp;</label>
							<div class="btn-group w-100">
								<button type="button" class="btn btn-sm text-nowrap" :class="voceSelezionata.FLG_ESCLUDI_TOTALE_VENDITA == 1 ? 'btn-primary' : 'btn-light'"
									title="Non sommare: la vendita resta visibile ma non entra nei totali di attività e progetto"
									@click="toggleFlag('FLG_ESCLUDI_TOTALE_VENDITA')"><i class="ph-eye me-1"></i>Non sommare</button>
								<button type="button" class="btn btn-sm text-nowrap" :class="voceSelezionata.FLG_ESCLUDI_FEE_VENDITA == 1 ? 'btn-primary' : 'btn-light'"
									title="Escludi dalla fee di progetto: la vendita non partecipa al calcolo della fee"
									@click="toggleFlag('FLG_ESCLUDI_FEE_VENDITA')"><i class="ph-percent me-1"></i>No fee</button>
								<button type="button" class="btn btn-sm text-nowrap" :class="voceSelezionata.FLG_NETTO_IVA_VENDITA == 1 ? 'btn-primary' : 'btn-light'"
									title="Netto IVA: nessuna IVA calcolata sulla vendita, il valore mostrato è il netto"
									@click="toggleFlag('FLG_NETTO_IVA_VENDITA')"><i class="ph-receipt me-1"></i>Netto IVA</button>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-danger mb-1 mt-2"><i class="ph-shopping-cart me-1"></i><Translate :path="'dizionario.attivita.ACQUISTO'"></Translate></h6>
					<div class="row mb-2">
						<div class="col-6 col-md-1">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.QTA'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="voceSelezionata.QUANTITY_COST_ESPOSTO" placeholder="1"
								@input="calcolaTotaleCostoEsposto()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-md-1">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.RIP'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="voceSelezionata.DAYS_COST_ESPOSTO" placeholder="1"
								@input="calcolaTotaleCostoEsposto()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-costo-voce">
							<label class="form-label fw-semibold mb-1 text-nowrap" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COSTO_ACQ'"></Translate>
								<i class="ph-gift cursor-pointer float-end" :class="voceSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? 'text-success' : 'text-muted'" @click="toggleOmaggio('UNIT_COST_ESPOSTO')" :title="voceSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? 'Omaggio attivo: clicca per disattivare' : 'Clicca per impostare come omaggio'"></i>
							</label>
							<div class="position-relative">
								<input type="number" step="0.01" class="form-control form-control-sm"
									v-model.number="voceSelezionata.UNIT_COST_ESPOSTO" placeholder="0.00"
									:disabled="voceSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1"
									@input="calcolaTotaleCostoEsposto()"
									@blur="voceSelezionata.UNIT_COST_ESPOSTO = parseFloat(voceSelezionata.UNIT_COST_ESPOSTO || 0).toFixed(2)">
							</div>
						</div>
						<div class="col-6 col-iva-voce">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA'"></Translate></label>
							<select class="form-select form-select-sm" v-model="voceSelezionata.FK_ID_IVA_COSTO" :disabled="voceSelezionata.FLG_NETTO_IVA_ACQUISTO == 1">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in filters.getCodiciIvaAttivi()"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md-1">
							<label class="form-label mb-1 text-nowrap" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA'"></Translate> ({{ ivaAcquistoSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaAcquistoSommario.importo" disabled>
						</div>
						<div class="col-6 col-md-2">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="voceSelezionata.FLG_NETTO_IVA_ACQUISTO == 1 ? 'dizionario.attivita.TOTALE' : 'dizionario.attivita.TOTALE_ACQ_CON_IVA'"></Translate></label>
							<div class="position-relative">
								<input type="text" class="form-control form-control-sm bg-light text-danger fw-bold"
									:value="voceSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? $root.translate('dizionario.attivita.OMAGGIO') : ivaAcquistoSommario.totale" readonly>
							</div>
						</div>
						<div class="col-12 col-md">
							<label class="form-label mb-1 d-none d-md-block invisible" style="font-size:0.85rem;">&nbsp;</label>
							<div class="btn-group w-100">
								<button type="button" class="btn btn-sm text-nowrap" :class="voceSelezionata.FLG_ESCLUDI_TOTALE_ACQUISTO == 1 ? 'btn-danger' : 'btn-light'"
									title="Non sommare: acquisto e commissioni restano visibili ma non entrano nei totali di attività e progetto"
									@click="toggleFlag('FLG_ESCLUDI_TOTALE_ACQUISTO')"><i class="ph-eye me-1"></i>Non sommare</button>
								<button type="button" class="btn btn-sm text-nowrap" :class="voceSelezionata.FLG_NETTO_IVA_ACQUISTO == 1 ? 'btn-danger' : 'btn-light'"
									title="Netto IVA: nessuna IVA calcolata sull'acquisto, il valore mostrato è il netto"
									@click="toggleFlag('FLG_NETTO_IVA_ACQUISTO')"><i class="ph-receipt me-1"></i>Netto IVA</button>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-warning mb-1 mt-2"><i class="ph-handshake me-1"></i><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></h6>
					<div class="row">
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA_COMMISSIONI'"></Translate></label>
							<select class="form-select form-select-sm" v-model="voceSelezionata.FK_ID_IVA_COMMISSIONI" :disabled="voceSelezionata.FLG_NETTO_IVA_COMMISSIONI == 1">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in filters.getCodiciIvaAttivi()"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></label>
							<div class="position-relative">
								<input type="number" step="0.01" class="form-control form-control-sm"
									v-model.number="voceSelezionata.TOTAL_COST_PRIVATO" placeholder="0.00"
									:disabled="voceSelezionata.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1"
									@blur="voceSelezionata.TOTAL_COST_PRIVATO = parseFloat(voceSelezionata.TOTAL_COST_PRIVATO || 0).toFixed(2)">
							</div>
						</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA_COMMISSIONI'"></Translate> ({{ ivaCommissioniSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaCommissioniSommario.importo" disabled>
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="voceSelezionata.FLG_NETTO_IVA_COMMISSIONI == 1 ? 'dizionario.attivita.TOTALE' : 'dizionario.attivita.TOTALE_COMM_CON_IVA'"></Translate></label>
							<input type="text" class="form-control form-control-sm bg-light text-warning fw-bold"
								:value="ivaCommissioniSommario.totale" disabled>
						</div>
						<div class="col-12 col-md">
							<label class="form-label mb-1 d-none d-md-block invisible" style="font-size:0.85rem;">&nbsp;</label>
							<div class="btn-group w-100">
								<button type="button" class="btn btn-sm text-nowrap" :class="voceSelezionata.FLG_NETTO_IVA_COMMISSIONI == 1 ? 'btn-warning' : 'btn-light'"
									title="Netto IVA: nessuna IVA calcolata sulle commissioni, il valore mostrato è il netto"
									@click="toggleFlag('FLG_NETTO_IVA_COMMISSIONI')"><i class="ph-receipt me-1"></i>Netto IVA</button>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer py-2">
					<button type="button" class="btn btn-sm btn-link" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button v-if="voceSelezionata.ID_VOCE == 0 ? canCreateVoce : canEditVoce" type="button" class="btn btn-sm btn-secondary" @click="salvaVoce(false)"
						:disabled="!voceSelezionata.TITOLO_VOCE || !voceSelezionata.QUANTITY_PRICE">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CHIUDI'"></Translate>
					</button>
					<button v-if="voceSelezionata.ID_VOCE == 0 && canCreateVoce" type="button" class="btn btn-sm btn-primary" @click="salvaVoce(true)"
						:disabled="!voceSelezionata.TITOLO_VOCE || !voceSelezionata.QUANTITY_PRICE">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CONTINUA'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div>


	<div class="modal fade" id="popUpStorico" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0 p-2">
					<h6 class="modal-title">
						<i class="ph-clock-counter-clockwise me-2"></i>
						<Translate :path="'dizionario.attivita.STORICO_REVISIONI'"></Translate> — <strong>{{ filters.titoloConTipologia(progetto) }}</strong>
					</h6>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
						data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-2">
					<table class="table table-sm table-bordered mb-0">
						<thead>
							<tr class="bg-light">
								<th style="width:8%;">Rev.</th>
								<th style="width:22%;"><Translate :path="'dizionario.base.DATA'"></Translate></th>
								<th style="width:8%;"><Translate :path="'dizionario.attivita.REV_PADRE'"></Translate></th>
								<th><Translate :path="'dizionario.base.NOTE'"></Translate></th>
								<th style="width:12%;"><Translate :path="'dizionario.base.STATO'"></Translate></th>
								<th style="width:20%;" class="text-center"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="rev in paginatedListStorico.arr" :key="rev.ID_REVISIONE"
								:class="{ 'table-primary fw-semibold': revisioneVisualizzata && revisioneVisualizzata.ID_REVISIONE == rev.ID_REVISIONE }">
								<td class="text-center">{{ rev.PROGRESSIVO }}</td>
								<td>{{ rev.DATA_CREAZIONE }}</td>
								<td class="text-center">{{ rev.PROGRESSIVO_PADRE || '-' }}</td>
								<td>{{ rev.NOTE }}</td>
								<td class="text-center">
									<span v-if="rev.FLG_PUBBLICATA == 1" class="badge bg-secondary"><Translate :path="'dizionario.base.CONGELATA'"></Translate></span>
									<span v-else class="badge bg-success"><Translate :path="'dizionario.base.ATTIVA_F'"></Translate></span>
								</td>
								<td class="text-center">
									<a @click="visualizzaRevisione(rev); filters.closePopUp('popUpStorico')"
										class="btn btn-xs btn-primary btn-sm me-1 cursor-pointer">
										<i class="ph-eye"></i>
									</a>
									<a v-if="rev.FLG_PUBBLICATA == 1 && canEditProgetto && !bloccato"
										@click="ripristinaRevisioneStorico(rev); filters.closePopUp('popUpStorico')"
										class="btn btn-xs btn-warning btn-sm cursor-pointer">
										<i class="ph-arrow-counter-clockwise"></i>
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer bg-light p-1">
					<div class="flex-grow-1">
						<Pagine v-model="searchStorico.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListStorico.count"
										:numpagine="searchStorico.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
					</div>
					<button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i>Chiudi
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- PopUp Aggiungi Voce Preferita -->
	<div class="modal fade" id="popUpAggiungiVocePreferita" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-md">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-secondary text-white">
					<h6 class="modal-title"><i class="ph-star me-2"></i>Aggiungi ai Preferiti</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<label class="form-label fw-semibold">Come vuoi salvare questa voce come preferita?</label>
						<p class="text-muted mb-0">
							<strong>Voce:</strong> {{ vocePreferitaTemp.TITOLO_VOCE }}
						</p>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button v-if="canCreateVociPreferite" type="button" class="btn btn-secondary btn-sm" @click="salvaVocePreferitaSenzaAzienda()"
						:disabled="salvandoVocePreferita">
						<i class="ph-check me-1"></i>
						Senza Cliente
					</button>
					<button v-if="canCreateVociPreferite" type="button" class="btn btn-secondary btn-sm" @click="salvaVocePreferitaConAzienda()"
						:disabled="salvandoVocePreferita">
						<i class="ph-check me-1"></i>
						Con Cliente
					</button>
					<button v-if="canCreateVociPreferite" type="button" class="btn btn-secondary btn-sm" @click="salvaVocePreferitaDueVersioni()"
						:disabled="salvandoVocePreferita">
						<i class="ph-check me-1"></i>
						Entrambe
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modale Importa Voce Preferita -->
	<div class="modal fade" id="popUpImportaVocePreferita" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-info text-white">
					<h6 class="modal-title"><i class="fa fa-star me-2"></i>Importa Voce Preferita in "{{ attivitaPerAzioni?.TITOLO }}"</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<input type="text" class="form-control mb-2" placeholder="Cerca..."
						v-model="searchVocePreferitaImport.TITOLO.VALUE">

					<div v-if="vociPreferiteSelezionate.length > 0" class="alert alert-info py-1 mb-2">
						{{ vociPreferiteSelezionate.length }} {{ utils.plurale(vociPreferiteSelezionate.length, 'voce selezionata', 'voci selezionate') }}
					</div>

					<div style="height: 400px; overflow-y: auto;">
						<table class="table table-bordered table-hover table-striped text-nowrap">
							<thead class="sticky-top thead-bordered">
								<tr class="bg-secondary text-white">
									<th class="table-head-sm text-center" style="width:3%;" rowspan="2">
										<input type="checkbox" v-model="selectAllVociImport" @change="toggleSelectAllVociImport">
									</th>
									<th class="table-head-sm text-center" style="width:3%;" rowspan="2">#</th>
									<th class="table-head-sm text-center bg-secondary bg-opacity-75" style="width:55%;" colspan="6">VENDITA</th>
									<th class="table-head-sm text-center bg-secondary bg-opacity-75 text-yellow" style="width:29%;" colspan="4">ACQUISTO</th>
								</tr>
								<tr class="bg-secondary text-white">
									<th class="table-head-sm" style="width:18%;">Titolo</th>
									<th class="table-head-sm text-center" style="width:4%;">Q.tà</th>
									<th class="table-head-sm text-center" style="width:6%;">Rip.</th>
									<th class="table-head-sm text-end" style="width:8%;">Prezzo Unit.</th>
									<th class="table-head-sm text-end" style="width:11%;">Totale</th>
									<th class="table-head-sm" style="width:8%;">Cliente</th>
									<th class="table-head-sm text-end text-yellow" style="width:8%;">Costo Unit.</th>
									<th class="table-head-sm text-end text-yellow" style="width:9%;">Costi</th>
									<th class="table-head-sm text-end text-yellow" style="width:9%;">Commissioni</th>
									<th class="table-head-sm text-yellow" style="width:10%;">Fornitore</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(vp, index) in paginatedVociPreferiteImport.arr" :key="vp.ID_VOCE_PREFERITA"
									@click="toggleVocePreferitaImport(vp.ID_VOCE_PREFERITA)" style="cursor: pointer;">
									<td class="table-head-sm text-center">
										<input type="checkbox" :checked="vociPreferiteSelezionate.includes(vp.ID_VOCE_PREFERITA)" @click.stop @change="toggleVocePreferitaImport(vp.ID_VOCE_PREFERITA)">
									</td>
									<td class="table-head-sm text-center"><small>{{ index + 1 }}</small></td>
									<td class="table-head-sm" style="word-wrap: break-word; white-space: normal;">
										<i class="ph-file-text me-1 text-muted"></i><strong>{{ vp.TITOLO }}</strong>
										<div v-if="vp.TESTO_NOTE" class="text-muted small">{{ vp.TESTO_NOTE }}</div>
									</td>
									<td class="table-head-sm text-end">{{ parseFloat(vp.QUANTITY_PRICE) }}</td>
									<td class="table-head-sm text-end">{{ parseFloat(vp.DAYS_PRICE) }}</td>
									<td class="table-head-sm text-end"><span class="text-muted" style="font-size:0.75rem;">&euro; {{ filters.formattaImporto(vp.UNIT_PRICE) }}</span></td>
									<td class="table-head-sm text-end">
										<span class="text-primary fw-semibold">&euro; {{ filters.formattaImporto(vp.TOTAL_PRICE) }}</span>
										<span v-if="filters.getIvaCodeById(vp.FK_ID_IVA_PREZZO)"
											class="badge bg-secondary ms-1"
											style="font-size:0.65rem;"
											:title="filters.getIvaCodeById(vp.FK_ID_IVA_PREZZO).DESCRIZIONE">
											{{ filters.getIvaCodeById(vp.FK_ID_IVA_PREZZO).CUSTOM_1 }}
										</span>
									</td>
									<td class="table-head-sm">
										<span v-if="vp.AZIENDA" class="text-muted" style="font-size:0.75rem;">{{ filters.accorciaTesto(vp.AZIENDA, 30) }}</span>
										<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
									</td>
									<td class="table-head-sm text-end"><span class="text-muted" style="font-size:0.75rem;">&euro; {{ filters.formattaImporto(vp.UNIT_COST_ESPOSTO) }}</span></td>
									<td class="table-head-sm text-end">
										<span class="text-danger fw-semibold">&euro; {{ filters.formattaImporto(vp.TOTAL_COST_ESPOSTO) }}</span>
										<span v-if="filters.getIvaCodeById(vp.FK_ID_IVA_COSTO)"
											class="badge bg-secondary ms-1"
											style="font-size:0.65rem;"
											:title="filters.getIvaCodeById(vp.FK_ID_IVA_COSTO).DESCRIZIONE">
											{{ filters.getIvaCodeById(vp.FK_ID_IVA_COSTO).CUSTOM_1 }}
										</span>
									</td>
									<td class="table-head-sm text-end">
										<span class="text-warning" style="font-size:0.75rem;">&euro; {{ filters.formattaImporto(vp.UNIT_COST_PRIVATO)}}</span>
										<span v-if="vp.FLG_NETTO_IVA_COMMISSIONI != 1 && filters.getIvaCodeById(vp.FK_ID_IVA_COMMISSIONI)"
											class="badge bg-secondary ms-1"
											style="font-size:0.65rem;"
											:title="filters.getIvaCodeById(vp.FK_ID_IVA_COMMISSIONI).DESCRIZIONE">
											{{ filters.getIvaCodeById(vp.FK_ID_IVA_COMMISSIONI).CUSTOM_1 }}
										</span>
									</td>
									<td class="table-head-sm">
										<span v-if="vp.AZIENDA_FORNITORE" class="text-muted" style="font-size:0.75rem;">{{ filters.accorciaTesto(vp.AZIENDA_FORNITORE, 30) }}</span>
										<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
									</td>
								</tr>
								<tr v-if="paginatedVociPreferiteImport.arr?.length == 0">
									<td colspan="12" class="text-center text-muted">Nessuna voce preferita trovata</td>
								</tr>
							</tbody>
						</table>
					</div>

					<Pagine :search="searchVocePreferitaImport" :modalita="$root.isMobile ? 2 : 1" />
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button v-if="$root.hasFunzionalita('VOCI_PREFERITE_IMPORT')" type="button" class="btn btn-primary btn-sm"
						:disabled="vociPreferiteSelezionate.length == 0"
						@click="eseguiImportaVocePreferita()">
						<i class="fa fa-plus me-1"></i>Importa {{ vociPreferiteSelezionate.length > 0 ? `(${vociPreferiteSelezionate.length})` : '' }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modale Import Excel Offline -->
	<ImportAttivitaExcel
		v-if="showImportAttivitaExcel"
		:idProgetto="progetto.ID_PROGETTO"
		:idRevisione="revisioneCorrente.ID_REVISIONE"
		@imported="getAttivita(); showImportAttivitaExcel = false"
		@close="showImportAttivitaExcel = false"
	/>

	<!-- Modale Template di stampa Budget PDF -->
	<ReportTemplateModal id="popUpStampaBudget" :idReport="1006" :urlStampa="urlStampaBudget"></ReportTemplateModal>

	<!-- Modale Modalità Esportazione Excel -->
	<div class="modal fade" id="popUpModalitaEsportazione" role="dialog" tabindex="-1" data-bs-backdrop="static">
		<div class="modal-dialog modal-md" role="document">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-success text-white">
					<h6 class="modal-title">
						<i class="far fa-file-excel me-2"></i>Seleziona Modalità Esportazione
					</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<label class="form-label fw-semibold">In che modalità vuoi esportarla?</label>
						<select class="form-select" v-model="modalitaEsportazioneSelezionata">
							<option value="">Seleziona una modalità...</option>
							<option v-for="opzione in arrayModalitaEsportazione" :key="opzione.ID_OPZIONE_TIPOLOGICA"
								:value="opzione.ICONA">
								{{ opzione.DESCRIZIONE }}
							</option>
						</select>
					</div>

					<!-- Spiegazioni modalità -->
					<div v-if="modalitaEsportazioneSelezionata == 1005" class="alert alert-info mb-0 mx-3">
						<div class="fw-semibold mb-1">
							<i class="far fa-info-circle me-1"></i>Modalità MISTA
						</div>
						<div class="small">
							Le <strong>attività principali</strong> (stesso livello) verranno esportate su <strong>fogli separati</strong>.
							Assicurati che le attività principali siano tutte allo stesso livello gerarchico.
						</div>
					</div>

					<div v-if="modalitaEsportazioneSelezionata == 1007" class="alert alert-info mb-0 mx-3">
						<div class="fw-semibold mb-1">
							<i class="far fa-info-circle me-1"></i>Modalità UNICA
						</div>
						<div class="small">
							Tutte le attività verranno esportate in un <strong>unico foglio</strong>.
							<br>Se vuoi che il foglio porti il nome del progetto, crea un'attività principale che racchiuda tutte le altre.
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-times me-1"></i> Annulla
					</button>
					<button type="button" class="btn btn-success" @click="confermaEsportazioneExcel()">
						<i class="far fa-file-excel me-1"></i> Esporta
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal: Scelta tipo creazione attività -->
	<div class="modal fade" id="popUpSceltaTipoCreazione" tabindex="-1" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-md" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">Aggiungi Attività</h5>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="row g-3">
						<!-- Card 1: Crea Attività -->
						<div class="col-6">
							<div class="card h-100 cursor-pointer border-primary text-center p-4"
								 @click="filters.closePopUp('popUpSceltaTipoCreazione'); creaAttivita({})">
								<i class="ph-plus-circle fs-1 text-primary mb-2"></i>
								<h6>Crea Attività</h6>
							</div>
						</div>
						<!-- Card 2: Importa da altro progetto -->
						<div class="col-6">
							<div class="card h-100 cursor-pointer border-success text-center p-4"
								 @click="apriImportaAttivita()">
								<i class="ph-copy fs-1 text-success mb-2"></i>
								<h6>Importa attività e voci da un altro progetto</h6>
							</div>
						</div>
						<!-- Card 3-4: extra nati durante l'evento, vanno direttamente a consuntivo -->
						<div class="col-6">
							<div class="card h-100 cursor-pointer border-warning text-center p-4"
								 @click="filters.closePopUp('popUpSceltaTipoCreazione'); creaAttivita({ FLG_CONSUNTIVO: 1 })">
								<i class="ph-folder-plus fs-1 text-warning mb-2"></i>
								<h6><Translate :path="'dizionario.attivita.NUOVA_ATTIVITA_CONSUNTIVO'"></Translate></h6>
							</div>
						</div>
						<div class="col-6">
							<div class="card h-100 cursor-pointer border-warning text-center p-4"
								 @click="filters.closePopUp('popUpSceltaTipoCreazione'); creaVoce({ ID_ATTIVITA: 0, TITOLO: $root.translate('dizionario.attivita.CONSUNTIVO') })">
								<i class="ph-plus-square fs-1 text-warning mb-2"></i>
								<h6><Translate :path="'dizionario.attivita.NUOVA_VOCE_CONSUNTIVO'"></Translate></h6>
							</div>
						</div>
						<template v-if="$root.hasFunzionalita('PROGETTO_UPDATE')">
							<div class="col-6">
							<div class="card cursor-pointer border-danger text-center p-3"
								 @click="filters.closePopUp('popUpSceltaTipoCreazione'); apriStorni()">
								<h6 class="mb-0"><i class="ph-minus-circle text-danger me-2"></i><Translate :path="'dizionario.attivita.STORNI'"></Translate></h6>
							</div>
						</div>
							<div class="col-6">
								<div class="card cursor-pointer border-secondary text-center p-3"
									 @click="filters.closePopUp('popUpSceltaTipoCreazione'); apriSconti()">
									<h6 class="mb-0"><i class="ph-percent text-secondary me-2"></i><Translate :path="'dizionario.attivita.SCONTO'"></Translate></h6>
					</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal: Sconti del preventivo (tolti dal Totale Imponibile, gestiti come gli storni) -->
	<div class="modal fade" id="popUpSconti" tabindex="-1" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title"><Translate :path="'dizionario.attivita.SCONTO'"></Translate></h5>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<small class="text-muted d-block mb-2">Importi in euro tolti dal Totale Imponibile del preventivo</small>
					<div v-for="(sc, i) in scontiInModifica" :key="i" class="row g-2 mb-2 align-items-center">
						<div class="col-8">
							<input type="text" class="form-control form-control-sm" v-model="sc.DESCRIZIONE" :placeholder="$root.translate('dizionario.attivita.DESCRIZIONE')">
						</div>
						<div class="col-3">
					<div class="input-group input-group-sm">
						<span class="input-group-text">- &euro;</span>
								<input type="number" step="0.01" min="0" class="form-control" v-model.number="sc.IMPORTO">
					</div>
						</div>
						<div class="col-1 text-end">
							<button type="button" class="btn btn-sm btn-light btn-icon" @click="scontiInModifica.splice(i, 1)"><i class="far fa-trash-alt"></i></button>
						</div>
					</div>
					<button type="button" class="btn btn-sm btn-light" @click="scontiInModifica.push({ DESCRIZIONE: '', IMPORTO: 0 })">
						<i class="far fa-plus me-1"></i><Translate :path="'dizionario.base.BTN_NUOVO'"></Translate>
					</button>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-sm btn-secondary" @click="salvaSconti()"><Translate :path="'dizionario.base.BTN_SALVA'"></Translate></button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal: Storni del consuntivo (servizi preventivati e non erogati) -->
	<div class="modal fade" id="popUpStorni" tabindex="-1" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title"><Translate :path="'dizionario.attivita.STORNI'"></Translate></h5>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<small class="text-muted d-block mb-2"><Translate :path="'dizionario.attivita.STORNI_NOTA'"></Translate></small>
					<div v-for="(st, i) in storniInModifica" :key="i" class="row g-2 mb-2 align-items-center">
						<div class="col-8">
							<input type="text" class="form-control form-control-sm" v-model="st.DESCRIZIONE" :placeholder="$root.translate('dizionario.attivita.DESCRIZIONE')">
						</div>
						<div class="col-3">
							<div class="input-group input-group-sm">
								<span class="input-group-text">- &euro;</span>
								<input type="number" step="0.01" min="0" class="form-control" v-model.number="st.IMPORTO">
							</div>
						</div>
						<div class="col-1 text-end">
							<button type="button" class="btn btn-sm btn-light btn-icon" @click="storniInModifica.splice(i, 1)"><i class="far fa-trash-alt"></i></button>
						</div>
					</div>
					<button type="button" class="btn btn-sm btn-light" @click="storniInModifica.push({ DESCRIZIONE: '', IMPORTO: 0 })">
						<i class="far fa-plus me-1"></i><Translate :path="'dizionario.base.BTN_NUOVO'"></Translate>
					</button>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-sm btn-secondary" @click="salvaStorni()"><Translate :path="'dizionario.base.BTN_SALVA'"></Translate></button>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="popUpEliminaSelezionati" tabindex="-1" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title"><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate></h5>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<p class="mb-2">Verranno eliminati:</p>
					<ul class="mb-3">
						<li v-if="riepilogoElimina.ATTIVITA.length">{{ riepilogoElimina.ATTIVITA.length }} attività (con {{ riepilogoElimina.VOCI_IN_ATTIVITA }} voci)</li>
						<li v-if="riepilogoElimina.VOCI.length">{{ riepilogoElimina.VOCI.length }} voci</li>
						<li v-if="riepilogoElimina.STORNI">{{ riepilogoElimina.STORNI }} storni</li>
						<li v-if="riepilogoElimina.SCONTI">{{ riepilogoElimina.SCONTI }} sconti</li>
					</ul>
					<div class="form-check">
						<input type="checkbox" class="form-check-input" id="chkMantieniAttivita" v-model="mantieniAttivita">
						<label class="form-check-label" for="chkMantieniAttivita">Mantieni le attività, elimina solo le voci</label>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button type="button" class="btn btn-sm btn-danger" @click="confermaEliminaSelezionati()"><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate></button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal: Importa attività da altro progetto -->
	<div class="modal fade" id="popUpImportaAttivita" tabindex="-1" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">Importa Attività da Altro Progetto</h5>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<!-- Select progetto -->
					<div class="mb-3">
						<label class="form-label">Seleziona Progetto</label>
						<select class="form-select" v-model="progettoSelezionatoPerImport"
								@change="onProgettoImportChange()">
							<option :value="null" disabled>-- Scegli un progetto --</option>
							<option v-for="p in progettiPerImport" :key="p.ID_PROGETTO"
									:value="p.ID_PROGETTO">{{ filters.titoloConTipologia(p) }} ({{ p.CODICE }})</option>
						</select>
					</div>

					<div v-if="revisioniPerImport.length > 0" class="mb-3 d-flex flex-wrap gap-1">
						<button v-for="rev in revisioniPerImport" :key="rev.ID_REVISIONE"
							class="btn btn-sm"
							:class="rev.ID_REVISIONE == revisioneSelezionataPerImport ? 'btn-primary' : 'btn-outline-secondary'"
							@click="onRevisioneImportChange(rev.ID_REVISIONE)">
							Rev. {{ rev.PROGRESSIVO }}
							<span v-if="basketCountsByRevision[rev.ID_REVISIONE] > 0" class="badge bg-warning text-dark ms-1">
								{{ basketCountsByRevision[rev.ID_REVISIONE] }}
							</span>
						</button>
					</div>

					<div v-if="attivitaSelezionatePerImport.length > 0" class="alert alert-info py-1 mb-2">
						{{ attivitaSelezionatePerImport.length }} attività selezionate per l'importazione
					</div>

					<div v-if="loadingImport" class="text-center py-4">
						<div class="spinner-border text-primary" role="status"></div>
					</div>

					<div v-else-if="attivitaPerImport.length > 0">
						<div class="mb-2 d-flex align-items-center gap-2">
							<input type="checkbox" id="chkAllAttivitaImport"
								v-model="selectAllAttivitaImport"
								@change="toggleSelectAllAttivitaImport">
							<label for="chkAllAttivitaImport" class="mb-0">Seleziona tutti</label>
						</div>
						<TabAttivitaImport
							v-for="attivita in attivitaPerImport"
							:key="attivita.ID_ATTIVITA"
							:attivita="attivita"
							:filters="filters"
							:selezionati="idAttivitaSelezionateCorrente"
							@toggleSelezionato="toggleAttivitaSelezionataPerImport($event)" />
					</div>

					<div v-else-if="progettoSelezionatoPerImport" class="text-muted text-center py-3">
						Nessuna attività trovata in questo progetto.
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
					<button class="btn btn-primary btn-sm"
						:disabled="attivitaSelezionatePerImport.length == 0"
						@click="importaAttivitaSelezionate()">
						<i class="ph-copy me-1"></i>
						Importa{{ attivitaSelezionatePerImport.length > 0 ? ` (${attivitaSelezionatePerImport.length})` : '' }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<SchedaAzienda ref="schedaAziendaFornitore" :tipo="2" @aziendaSalvata="onFornitoreCreato"></SchedaAzienda>

	<ModalNuovaRevisione
		ref="modalNuovaRevisione"
		:fk-id-progetto="progetto.ID_PROGETTO"
		:progressivo-corrente="revisioneCorrente ? revisioneCorrente.PROGRESSIVO : 0"
		@revisione-creata="onRevisioneCreata()"
	/>

	<ModalNuovaSpesa
		v-if="showModalNuovaSpesa"
		:defaultIdProgetto="progetto.ID_PROGETTO"
		:notaSpesa="notaSpesaInEdit"
		@close="showModalNuovaSpesa = false; notaSpesaInEdit = null"
		@saved="showModalNuovaSpesa = false; notaSpesaInEdit = null; getNoteSpese()"
	/>

	<ModalAllegati v-if="voceAllegati" tipo="voce" :id="voceAllegati.ID_VOCE" :titolo="voceAllegati.TITOLO_VOCE" @close="voceAllegati = null" />
	<ModalImputazioneVoce v-if="voceFattura" :voce="voceFattura" @close="voceFattura = null" @salvato="getAttivita()" />
</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import AttivitaNode from '@/components/AttivitaNode.vue'
import Select2 from '@/components/utils/Select2.vue'
import ColorPicker from '@/components/utils/ColorPicker.vue'
import SchedaAzienda from '@/components/SchedaAzienda.vue'
import TabAttivitaImport from '@/components/utils/TabAttivitaImport.vue'
import ModalNuovaRevisione from '@/components/ModalNuovaRevisione.vue'
import NoteSpeseProg from '@/components/NoteSpeseProg.vue'
import ModalNuovaSpesa from '@/components/ModalNuovaSpesa.vue'
import { VueDraggableNext } from 'vue-draggable-next'
import ImportAttivitaExcel from '@/components/ImportAttivitaExcel.vue'
import ReportTemplateModal from '@/components/common/ReportTemplateModal.vue'
import ModalAllegati from '@/components/ModalAllegati.vue'
import ModalImputazioneVoce from '@/components/ModalImputazioneVoce.vue'
import SchedaVisualizzazioneProgetto from '@/components/SchedaVisualizzazioneProgetto.vue'
import SchedaProgetto from '@/components/SchedaProgetto.vue'
import ClassicEditor from '@/utils/CustomCKEditor'


export default {
	name: 'Attivita',

	components: {
		ReportTemplateModal,
		Pagine,
		ISwitch,
		AttivitaNode,
		Select2,
		ColorPicker,
		SchedaAzienda,
		TabAttivitaImport,
		ModalNuovaRevisione,
		NoteSpeseProg,
		ModalNuovaSpesa,
		draggable: VueDraggableNext,
		ImportAttivitaExcel,
		ModalAllegati,
		ModalImputazioneVoce,
		SchedaVisualizzazioneProgetto,
		SchedaProgetto
	},

	data: function () {
		return {
			filters: global.filters,
			utils: global.utils,
			arrayStatiProgetto: global.filters.getOpzioniTipologiche(58, 1),
			GLOBAL_IMAGES_PATH: '',
			anno: new Date().getFullYear(),
			arrayAttivita: new Array(),
			attivitaSelezionata: {},
			draggingRootAttivita: null,
			search: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				ID_ATTIVITA: { TYPE: 'TEXT', VALUE: '' },
				ID_VOCE: { TYPE: 'TEXT', VALUE: '' },
				FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '1' },
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				TITOLO_VOCE: { TYPE: 'TEXT', VALUE: '' },
				FLG_DA_CALCOLARE: { TYPE: 'COMBO', VALUE: '' },
				FLG_ELIMINATO: { TYPE: 'COMBO', VALUE: '0' },
			},
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
                // The configuration of the editor.
            },
			voceSelezionata: {},
			attivitaPerVoce: {},
			attivitaPerAzioni: {},
			vocePerAzioni: {},
			attivitaPerAzioniVoce: {},
			voceAllegati: null,
			voceFattura: null,
			progetto: {},
			ordinamento: '',
			revisioni: [],
			revisioneCorrente: null,
			revisioneVisualizzata: null,
			revisionePerRipristino: null,
			noteRipristinaRevisione: '',
			allExpanded: true,
			tuttiSelezionati: false,
			mantieniAttivita: false,
			vocePreferitaTemp: {},
			salvandoVocePreferita: false,
			hasUnsavedChanges: false,
			lock: null,
			lockHandle: null,
			saving: false,
			editMode: false,
			searchStorico: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				ID_ATTIVITA: { TYPE: 'TEXT', VALUE: '' },
				ID_VOCE: { TYPE: 'TEXT', VALUE: '' },
				FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '1' },
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				TITOLO_VOCE: { TYPE: 'TEXT', VALUE: '' },
				FLG_DA_CALCOLARE: { TYPE: 'COMBO', VALUE: '' },
			},

			// Modalità esportazione Excel
			arrayModalitaEsportazione: new Array(),
			modalitaEsportazioneSelezionata: null,

			showImportAttivitaExcel: false,

			// Toggle per visualizzare percentuale del margine
			showMarginePercentage: false,
			// Toggle per mostrare valori IVA inclusa
			showIva: false,

			omaggioBackup: {},

			// Dati per import da altro progetto
			progettiPerImport: [],
			progettoSelezionatoPerImport: null,
			attivitaPerImport: [],
			loadingImport: false,
			revisioniPerImport: [],
			revisioneSelezionataPerImport: null,
			attivitaSelezionatePerImport: [],

			// Dati per importa voce preferita
			vociPreferitePerImport: [],
			vociPreferiteSelezionate: [],
			selectAllVociImport: false,
			searchVocePreferitaImport: {
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 }
			},

			// Consuntivo: nodo virtuale (null se vuoto) e storni del progetto
			nodoConsuntivo: null,
			arrayStorni: [],
			storniInModifica: [],
			arraySconti: [],
			scontiInModifica: [],
			// Filtri locali fuori da search: inGridRicorsiva li applicherebbe ai campi dei nodi
			filtroFornitore: 0,
			mostraSconti: '1',
			mostraStorni: '1',

			// Note Spese
			arrayNoteSpese: [],
			showModalNuovaSpesa: false,
			notaSpesaInEdit: null,
		}

	},

	methods: {
		getPct(value) {
			const budget = parseFloat(this.getTotali.BUDGET) || 0;
			if (budget == 0) return '';
			return ((parseFloat(value) || 0) / budget * 100).toFixed(1) + '% del budget';
		},

		getNoteSpese() {
			if (!this.progetto || !this.progetto.ID_PROGETTO) return;
			utils.get('theb/note_spese/progetto', { FK_ID_PROGETTO: this.progetto.ID_PROGETTO}, (response) => {
				if (response.esito == 0) {
					this.arrayNoteSpese = response.data;
				}
			});
		},

		/**
		 * Calcola la percentuale del margine rispetto al budget
		 */
		getMarginePercentage: function () {
			const budget = parseFloat(this.getTotali.GRAND_TOTAL) || 0;
			const margine = parseFloat(this.getTotali.MARGINE) || 0;
			if (budget == 0) return 0;
			return ((margine / budget) * 100).toFixed(2);
		},

		/**
		 * Toggle visualizzazione percentuale margine
		 */
		toggleMarginePercentage: function () {
			this.showMarginePercentage = !this.showMarginePercentage;
		},

		getAttivita(idRevisione = null) {
			this.progetto = utils.clone(this.$root.progetto);
			const payload = {
				FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
				IS_GOD: this.$root.isGod ? 1 : 0
			};
			if (idRevisione !== null) payload.FK_ID_REVISIONE = idRevisione;
			this.tuttiSelezionati = false;
			utils.get("theb/attivita/lista", payload, (response) => {
				this.arrayAttivita = response.data || [];
				this.marcaConsuntivo(this.arrayAttivita, false, true);
			});
			utils.get("theb/attivita/consuntivo", payload, (response) => {
				const data = response.data || {};
				this.arrayStorni = data.STORNI || [];
				this.arraySconti = data.SCONTI || [];
				this.nodoConsuntivo = this.preparaNodoConsuntivo(data.NODO);
			});
		},

		// Il nodo arriva dal backend (o si crea vuoto se ci sono solo storni). IN_CONSUNTIVO
		// marca tutto il contenuto: i menu offrono "Riporta a preventivo" solo a chi ha il flag.
		preparaNodoConsuntivo(nodo) {
			if (!nodo && this.arrayStorni.length == 0) return null;
			nodo = nodo || { ID_ATTIVITA: 0, FLG_VIRTUALE: 1, FLG_CONSUNTIVO: 1, FLG_ATTIVO: 1, FLG_DA_CALCOLARE: 1, FLG_ELIMINATO: 0, VOCI: [], SOTTO_ATTIVITA: [], SUBTOTALE_BUDGET: 0, SUBTOTALE_BUDGET_FEE: 0, SUBTOTALE_ESPOSTO: 0, SUBTOTALE_PRIVATO: 0 };
			nodo.TITOLO = this.$root.translate('dizionario.attivita.CONSUNTIVO');
			nodo.COLORE = '#595959';
			nodo.STORNI = this.arrayStorni;
			this.marcaConsuntivo([nodo], true);
			return nodo;
		},

		openOffCanvas: function () {
			var myOffcanvas = document.getElementById('panel_right')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
		},
		
		openSchedaVisualizzazioneProgetto: function () {
			this.$refs.schedaVisualizzazioneProgetto.openSchedaVisualizzazioneProgetto(this.progetto);
		},

		// Dalla scheda di visualizzazione: chiude l'offcanvas e apre la scheda
		// di modifica esistente sullo stesso progetto (stesso flusso di Progetti.vue).
		modificaProgetto: function (progetto) {
			var myOffcanvas = document.getElementById('panel_right');
			if (myOffcanvas) {
				var bsOffcanvas = bootstrap.Offcanvas.getInstance(myOffcanvas);
				if (bsOffcanvas) {
					bsOffcanvas.hide();
				}
			}
			const selezionato = progetto && progetto.ID_PROGETTO ? progetto : this.progetto;
			this.$refs.schedaProgetto.openSchedaProgetto(utils.clone(selezionato));
		},

		// IN_CONSUNTIVO su chi ha il flag o lo eredita da un'attività antenata: i menu offrono "Riporta" solo a chi ha il flag.
		// Nell'albero del preventivo (fuoriPreventivo) gli stessi elementi restano visibili ma segnalati
		// con FUORI_PREVENTIVO (badge + riga attenuata) e restano fuori da totali e IVA.
		// Copia dell'albero con le sole voci del fornitore filtrato e i subtotali ricalcolati
		// (stesse regole di Attivita::calcolaSubtotali); le attivita' rimaste vuote spariscono
		filtraPerFornitore(nodi, escludiConsuntivo) {
			const out = [];
			(nodi || []).forEach(att => {
				const copia = Object.assign({}, att);
				copia.VOCI = (att.VOCI || []).filter(v => v.FK_ID_AZIENDA_FORNITORE == this.filtroFornitore);
				copia.SOTTO_ATTIVITA = this.filtraPerFornitore(att.SOTTO_ATTIVITA, escludiConsuntivo);
				if (!copia.VOCI.length && !copia.SOTTO_ATTIVITA.length && !copia.FLG_VIRTUALE) return;
				let budget = 0, budgetFee = 0, esposto = 0, privato = 0;
				const vendita = copia.FLG_DA_CALCOLARE == 1;
				copia.VOCI.forEach(v => {
					if ((escludiConsuntivo && v.FLG_CONSUNTIVO == 1) || v.FLG_ATTIVO_VOCE != 1) return;
					if (vendita && v.FLG_DA_CALCOLARE == 1 && v.FLG_ESCLUDI_TOTALE_VENDITA != 1) {
						budget += parseFloat(v.TOTAL_PRICE) || 0;
						if (v.FLG_ESCLUDI_FEE_VENDITA != 1) budgetFee += parseFloat(v.TOTAL_PRICE) || 0;
					}
					if (v.FLG_ESCLUDI_TOTALE_ACQUISTO != 1) {
						esposto += parseFloat(v.TOTAL_COST_ESPOSTO) || 0;
						privato += parseFloat(v.TOTAL_COST_PRIVATO) || 0;
					}
				});
				copia.SOTTO_ATTIVITA.forEach(sub => {
					if ((escludiConsuntivo && sub.FLG_CONSUNTIVO == 1) || sub.FLG_ATTIVO != 1) return;
					if (vendita) {
						budget += sub.SUBTOTALE_BUDGET;
						budgetFee += sub.SUBTOTALE_BUDGET_FEE;
					}
					esposto += sub.SUBTOTALE_ESPOSTO;
					privato += sub.SUBTOTALE_PRIVATO;
				});
				const r = (n) => Math.round(n * 100) / 100;
				copia.SUBTOTALE_BUDGET = r(budget);
				copia.SUBTOTALE_BUDGET_FEE = r(budgetFee);
				copia.SUBTOTALE_ESPOSTO = r(esposto);
				copia.SUBTOTALE_PRIVATO = r(privato);
				out.push(copia);
			});
			return out;
		},

		marcaConsuntivo(nodi, ereditato, fuoriPreventivo = false) {
			(nodi || []).forEach(att => {
				const dentro = ereditato || att.FLG_CONSUNTIVO == 1;
				if (dentro) {
					att.IN_CONSUNTIVO = 1;
					if (fuoriPreventivo) att.FUORI_PREVENTIVO = 1;
				}
				(att.VOCI || []).forEach(v => {
					if (dentro || v.FLG_CONSUNTIVO == 1) {
						v.IN_CONSUNTIVO = 1;
						if (fuoriPreventivo) v.FUORI_PREVENTIVO = 1;
					}
				});
				this.marcaConsuntivo(att.SOTTO_ATTIVITA, dentro, fuoriPreventivo);
			});
		},

		apriStorni() {
			this.storniInModifica = this.arrayStorni.map(st => ({ DESCRIZIONE: st.DESCRIZIONE, IMPORTO: Math.abs(parseFloat(st.IMPORTO) || 0) }));
			if (this.storniInModifica.length == 0) this.storniInModifica.push({ DESCRIZIONE: '', IMPORTO: 0 });
			this.filters.openPopUp('popUpStorni');
		},

		salvaStorni() {
			const storni = this.storniInModifica.filter(st => (parseFloat(st.IMPORTO) || 0) != 0);
			utils.put('theb/progetto/storni', { ID_BUDGET: this.progetto.ID_PROGETTO, STORNI: storni }, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Storni salvati.');
					this.filters.closePopUp('popUpStorni');
					this.getAttivita();
				}
			});
		},

		apriSconti() {
			this.scontiInModifica = this.arraySconti.map(sc => ({ DESCRIZIONE: sc.DESCRIZIONE, IMPORTO: Math.abs(parseFloat(sc.IMPORTO) || 0) }));
			if (this.scontiInModifica.length == 0) this.scontiInModifica.push({ DESCRIZIONE: '', IMPORTO: 0 });
			this.filters.openPopUp('popUpSconti');
		},

		salvaSconti() {
			const sconti = this.scontiInModifica.filter(sc => (parseFloat(sc.IMPORTO) || 0) != 0);
			// Nell'albero la riga sconto mostra solo la descrizione: senza, non si capirebbe cos'e'
			if (sconti.some(sc => !(sc.DESCRIZIONE || '').trim())) {
				utils.alert.warning('Inserisci la descrizione di ogni sconto.');
				return;
			}
			utils.put('theb/progetto/sconti', { ID_BUDGET: this.progetto.ID_PROGETTO, SCONTI: sconti }, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Sconti salvati.');
					this.filters.closePopUp('popUpSconti');
					this.getAttivita();
				}
			});
		},

		toggleConsuntivo(tipo, id, flgAttuale) {
			const params = { FLG_CONSUNTIVO: flgAttuale == 1 ? 0 : 1 };
			params[tipo == 'voce' ? 'ID_VOCE' : 'ID_ATTIVITA'] = id;
			utils.put('theb/' + tipo + '/consuntivo', params, (response) => {
				if (response.esito == 0) {
					this.getAttivita();
				}
			});
		},

		caricaRevisioni() {
			utils.get('theb/revisione/lista', { FK_ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
				if (response.esito == 0) {
					this.revisioni = response.data || [];
					this.revisioneCorrente = this.revisioni[this.revisioni.length - 1] || null;
					this.revisioneVisualizzata = this.revisioneCorrente;
				}
			});
		},

		visualizzaRevisione(revisione) {
			this.revisioneVisualizzata = revisione;
			this.getAttivita(revisione.ID_REVISIONE);
		},

		creaRevisione() {
			this.$refs.modalNuovaRevisione.apri();
		},

		onRevisioneCreata() {
			this.caricaRevisioni();
			this.getAttivita();
		},

		ripristinaRevisioneStorico(revisione) {
			utils.alert.confirm('Vuoi ripristinare la Revisione ' + revisione.PROGRESSIVO + '?', () => {
				setTimeout(() => {
					utils.alert.confirm('Verrà creata una nuova revisione che è copia della Rev. ' + revisione.PROGRESSIVO + '. Confermi?', () => {
						utils.put('theb/revisione/ripristina', {
							ID_BUDGET: this.progetto.ID_PROGETTO,
							PROGRESSIVO: revisione.PROGRESSIVO,
							ID_REVISIONE: revisione.ID_REVISIONE,
						}, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Revisione ripristinata!');
								this.caricaRevisioni();
								this.getAttivita();
							}
						});
					}, this.$root);
				}, 400);
			}, this.$root);
		},

		flattenAttivita(nodi, risultato) {
			for (var i = 0; i < nodi.length; i++) {
				risultato.push(nodi[i]);
				if (nodi[i].SOTTO_ATTIVITA && nodi[i].SOTTO_ATTIVITA.length > 0) {
					this.flattenAttivita(nodi[i].SOTTO_ATTIVITA, risultato);
				}
			}
		},

		toggleAllAttivita() {
			const chk = document.getElementById('chkAllAttivita');
			this.allExpanded = chk.checked;
		},

		apriSceltaTipoCreazione() {
			this.filters.openPopUp('popUpSceltaTipoCreazione');
		},

		apriImportaAttivita() {
			this.filters.closePopUp('popUpSceltaTipoCreazione');
			this.progettoSelezionatoPerImport = null;
			this.attivitaPerImport = [];
			this.revisioniPerImport = [];
			this.revisioneSelezionataPerImport = null;
			this.attivitaSelezionatePerImport = [];
			this.selectAllAttivitaImport = false;
			utils.get("theb/progetto/lista", {}, (response) => {
				this.progettiPerImport = (response.data || []).filter(
					p => p.ID_PROGETTO !== this.progetto.ID_PROGETTO
				);
			});
			this.filters.openPopUp('popUpImportaAttivita');
		},


		onProgettoImportChange() {
			if (!this.progettoSelezionatoPerImport) return;
			this.loadingImport = true;
			this.revisioniPerImport = [];
			this.revisioneSelezionataPerImport = null;
			this.attivitaPerImport = [];
			utils.get('theb/revisione/lista', { FK_ID_PROGETTO: this.progettoSelezionatoPerImport }, (response) => {
				this.revisioniPerImport = response.data || [];
				const lastRev = this.revisioniPerImport[this.revisioniPerImport.length - 1];
				if (lastRev) {
					this.revisioneSelezionataPerImport = lastRev.ID_REVISIONE;
					this.caricaAttivitaPerImport(lastRev.ID_REVISIONE);
				} else {
					this.loadingImport = false;
				}
			});
		},

		prepareAttivitaImport(attivita) {
			return {
				...attivita,
				VOCI: attivita.VOCI || [],
				SOTTO_ATTIVITA: (attivita.SOTTO_ATTIVITA || []).map(s => this.prepareAttivitaImport(s)),
			};
		},

		importaAttivitaSelezionate() {
			if (!this.attivitaSelezionatePerImport.length) return;
			this.loadingImport = true;
			const items = [...this.attivitaSelezionatePerImport];
			const requests = items.map(item => new Promise((resolve) => {
				utils.post('theb/attivita/copia-albero', {
					ID_ATTIVITA_ORIGINE: item.ID_ATTIVITA,
					ID_BUDGET: this.progetto.ID_PROGETTO,
				}, () => resolve());
			}));
			Promise.all(requests).then(() => {
				this.filters.closePopUp('popUpImportaAttivita');
				this.getAttivita();
			});
		},

		caricaAttivitaPerImport(idRevisione) {
			this.loadingImport = true;
			utils.get('theb/attivita/lista', {
				FK_ID_PROGETTO: this.progettoSelezionatoPerImport,
				FK_ID_REVISIONE: idRevisione,
			}, (response) => {
				this.attivitaPerImport = (response.data || []).map(a => this.prepareAttivitaImport(a));
				this.loadingImport = false;
			});
		},

		onRevisioneImportChange(idRevisione) {
			this.revisioneSelezionataPerImport = idRevisione;
			this.selectAllAttivitaImport = false;
			this.caricaAttivitaPerImport(idRevisione);
		},

		toggleAttivitaSelezionataPerImport(attivita) {
			const idx = this.attivitaSelezionatePerImport.findIndex(
				a => a.ID_ATTIVITA == attivita.ID_ATTIVITA && a.ID_REVISIONE == this.revisioneSelezionataPerImport
			);
			if (idx >= 0) {
				this.attivitaSelezionatePerImport.splice(idx, 1);
			} else {
				const rev = this.revisioniPerImport.find(r => r.ID_REVISIONE == this.revisioneSelezionataPerImport);
				this.attivitaSelezionatePerImport.push({
					ID_ATTIVITA: attivita.ID_ATTIVITA,
					TITOLO: attivita.TITOLO,
					ID_REVISIONE: this.revisioneSelezionataPerImport,
					PROGRESSIVO: rev?.PROGRESSIVO,
				});
			}
		},

		toggleSelectAllAttivitaImport() {
			if (!this.selectAllAttivitaImport) {
				this.attivitaSelezionatePerImport = this.attivitaSelezionatePerImport
					.filter(a => a.ID_REVISIONE != this.revisioneSelezionataPerImport);
				return;
			}
			const rev = this.revisioniPerImport.find(r => r.ID_REVISIONE == this.revisioneSelezionataPerImport);
			const notYetSelected = this.attivitaPerImport.filter(
				a => !this.idAttivitaSelezionateCorrente.includes(a.ID_ATTIVITA)
			);
			this.attivitaSelezionatePerImport.push(...notYetSelected.map(a => ({
				ID_ATTIVITA: a.ID_ATTIVITA,
				TITOLO: a.TITOLO,
				ID_REVISIONE: this.revisioneSelezionataPerImport,
				PROGRESSIVO: rev?.PROGRESSIVO,
			})));
		},

		apriImportaVocePreferita(attivita) {
			this.attivitaPerAzioni = attivita;
			this.vociPreferiteSelezionate = [];
			this.searchVocePreferitaImport.TITOLO.VALUE = '';
			this.searchVocePreferitaImport.PAGINATION.PAGE_NUMBER = 1;

			utils.get('theb/voci_preferite/lista', {}, (response) => {
				this.vociPreferitePerImport = response.data || [];
				this.searchVocePreferitaImport.PAGINATION.LENGTH = this.vociPreferitePerImport.length;
				this.filters.openPopUp('popUpImportaVocePreferita');
			});
		},

		toggleVocePreferitaImport(id) {
			const index = this.vociPreferiteSelezionate.indexOf(id);
			if (index > -1) {
				this.vociPreferiteSelezionate.splice(index, 1);
			} else {
				this.vociPreferiteSelezionate.push(id);
			}
			this.selectAllVociImport = this.paginatedVociPreferiteImport.arr.every(vp => this.vociPreferiteSelezionate.includes(vp.ID_VOCE_PREFERITA));
		},

		toggleSelectAllVociImport() {
			if (this.selectAllVociImport) {
				this.vociPreferiteSelezionate = this.paginatedVociPreferiteImport.arr.map(vp => vp.ID_VOCE_PREFERITA);
			} else {
				this.vociPreferiteSelezionate = [];
			}
		},

		eseguiImportaVocePreferita() {
			if (this.vociPreferiteSelezionate.length == 0) {
				utils.alert.warning('Seleziona almeno una voce preferita');
				return;
			}

			const payload = {
				IDS_PREFERITE: this.vociPreferiteSelezionate,
				FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
				ID_ATTIVITA: this.attivitaPerAzioni.ID_ATTIVITA
			};

			utils.post('theb/voci_preferite/import', payload, (response) => {
				if (response.esito == 0) {
					utils.alert.success(response.messaggio || 'Voci preferite importate con successo!');
					this.vociPreferiteSelezionate = [];
					this.filters.closePopUp('popUpImportaVocePreferita');
					this.getAttivita();
				} else {
					utils.alert.danger(response.messaggio || 'Errore durante l\'importazione');
				}
			});
		},

		creaAttivita(opzioni) {
			this.attivitaSelezionata = {
				ID_ATTIVITA: 0,
				FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
				FK_ID_ATTIVITA: (opzioni && opzioni.FK_ID_ATTIVITA) ? opzioni.FK_ID_ATTIVITA : null,
				TITOLO: '',
				DESCRIZIONE: '',
				COLORE: '#A5A5A5',
				COLORE_TESTO: null,
				FLG_DA_CALCOLARE: 1,
				FLG_CONSUNTIVO: (opzioni && opzioni.FLG_CONSUNTIVO) ? 1 : 0,
			};
			this.filters.openPopUp('popUpAttivita');
		},

		modificaAttivita(attivita) {
			this.attivitaSelezionata = utils.clone(attivita);
			this.filters.openPopUp('popUpAttivita');
		},

		salvaAttivita(continua) {
			const isUpdate = this.attivitaSelezionata.ID_ATTIVITA > 0;
			const api = isUpdate ? "theb/attivita/update" : "theb/attivita/insert";
			(isUpdate ? utils.put : utils.post)(api, this.attivitaSelezionata, (response) => {
				if (response.esito == 0) {
					const msg = this.attivitaSelezionata.ID_ATTIVITA > 0 ? "aggiornata" : "creata";
					utils.alert.success(`Attività ${msg} con successo.`);
					utils.notifiche.invia(this, this.attivitaSelezionata.ID_ATTIVITA > 0 ? 'ATTIVITA_MODIFICA' : 'ATTIVITA_CREA', (this.attivitaSelezionata.ID_ATTIVITA > 0 ? 'ha modificato l\'attività "' : 'ha creato una nuova attività "') + this.attivitaSelezionata.TITOLO + '"');
					this.getAttivita();
					if (continua) {
						this.attivitaSelezionata = {
							ID_ATTIVITA: 0,
							FK_ID_PROGETTO: this.attivitaSelezionata.FK_ID_PROGETTO,
							FK_ID_ATTIVITA: this.attivitaSelezionata.FK_ID_ATTIVITA,
							FLG_CONSUNTIVO: this.attivitaSelezionata.FLG_CONSUNTIVO,
							TITOLO: '',
							DESCRIZIONE: '',
							COLORE: '#A5A5A5',
				COLORE_TESTO: null,
							FLG_DA_CALCOLARE: 1,
						};
					} else {
						this.filters.closePopUp("popUpAttivita");
					}
				}
			});
		},

		creaVoce(attivita) {
			this.attivitaPerVoce = attivita;
			this.voceSelezionata = {
				FK_ID_ATTIVITA: attivita.ID_ATTIVITA,
				FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
				FLG_CONSUNTIVO: attivita.ID_ATTIVITA == 0 ? 1 : 0,
				ID_VOCE: 0,
				TITOLO_VOCE: '',
				NOTE: '',
				COLORE: '#FFFFFF',
				COLORE_TESTO: null,
				FK_ID_AZIENDA: this.progetto.FK_ID_AZIENDA || null,
				FK_ID_AZIENDA_FORNITORE: null,
				QUANTITY_PRICE: 1,
				DAYS_PRICE: 1,
				QUANTITY_COST_ESPOSTO: 1,
				DAYS_COST_ESPOSTO: 1,
				UNIT_PRICE: 0,
				TOTAL_PRICE: 0,
				FK_ID_IVA_PREZZO: null,
				UNIT_COST_ESPOSTO: 0,
				TOTAL_COST_ESPOSTO: 0,
				FK_ID_IVA_COSTO: null,
				UNIT_COST_PRIVATO: 0,
				TOTAL_COST_PRIVATO: 0,
				FK_ID_IVA_COMMISSIONI: null,
				FLG_DA_CALCOLARE: 1,
				FLG_OMAGGIO_UNIT_PRICE: 0,
				FLG_OMAGGIO_TOTAL_PRICE: 0,
				FLG_OMAGGIO_UNIT_COST_ESPOSTO: 0,
				FLG_OMAGGIO_UNIT_COST_PRIVATO: 0,
				FLG_OMAGGIO_TOTAL_COST_PRIVATO: 0,
				FLG_ESCLUDI_TOTALE_VENDITA: 0,
				FLG_ESCLUDI_FEE_VENDITA: 0,
				FLG_NETTO_IVA_VENDITA: 1,
				FLG_ESCLUDI_TOTALE_ACQUISTO: 0,
				FLG_NETTO_IVA_ACQUISTO: 1,
				FLG_NETTO_IVA_COMMISSIONI: 1,
			};
			this.filters.openPopUp("popUpVoce");
		},

		modificaVoce(voce, attivita) {
			this.attivitaPerVoce = attivita || {};
			this.voceSelezionata = utils.clone(voce);
			this.filters.openPopUp('popUpVoce');
		},

		calcolaTotalePrezzo() {
			// Forza quantità e ripetizioni a valori interi
			const quantity = parseInt(this.voceSelezionata.QUANTITY_PRICE) || 0;
			const days = parseInt(this.voceSelezionata.DAYS_PRICE) || 1;
			const unitPrice = parseFloat(this.voceSelezionata.UNIT_PRICE) || 0;

			// Aggiorna i valori nel modello per rimuovere eventuali decimali
			this.voceSelezionata.QUANTITY_PRICE = quantity;
			this.voceSelezionata.DAYS_PRICE = days;

			this.voceSelezionata.TOTAL_PRICE = (unitPrice * quantity * days).toFixed(2);
		},

		calcolaTotaleCostoEsposto() {
			// Forza quantità e ripetizioni a valori interi
			const quantity = parseInt(this.voceSelezionata.QUANTITY_COST_ESPOSTO) || 0;
			const days = parseInt(this.voceSelezionata.DAYS_COST_ESPOSTO) || 1;
			const unitCostEsposto = parseFloat(this.voceSelezionata.UNIT_COST_ESPOSTO) || 0;

			// Aggiorna i valori nel modello per rimuovere eventuali decimali
			this.voceSelezionata.QUANTITY_COST_ESPOSTO = quantity;
			this.voceSelezionata.DAYS_COST_ESPOSTO = days;

			this.voceSelezionata.TOTAL_COST_ESPOSTO = (unitCostEsposto * quantity * days).toFixed(2);
		},

		toggleFlag(field) {
			this.voceSelezionata[field] = this.voceSelezionata[field] == 1 ? 0 : 1;
		},

		toggleOmaggio(field) {
			const flagField = `FLG_OMAGGIO_${field}`;
			const isOmaggio = this.voceSelezionata[flagField] == 1;
			this.voceSelezionata[flagField] = isOmaggio ? 0 : 1;

			if (!isOmaggio) {
				this.omaggioBackup[field] = this.voceSelezionata[field];
				this.voceSelezionata[field] = 0;
			} else {
				this.voceSelezionata[field] = this.omaggioBackup[field] ?? 0;
			}
			if (field == 'UNIT_COST_ESPOSTO') {
				this.calcolaTotaleCostoEsposto();
			} else if (field == 'UNIT_PRICE') {
				this.calcolaTotalePrezzo();
			}
		},

		calcolaTotaleCostoPrivato() {
			// Le commissioni vengono inserite manualmente dall'utente
			// Non c'è un calcolo automatico con quantità/ripetizioni
			const unitCostPrivato = parseFloat(this.voceSelezionata.UNIT_COST_PRIVATO) || 0;
			if (!this.voceSelezionata.TOTAL_COST_PRIVATO || this.voceSelezionata.TOTAL_COST_PRIVATO == 0) {
				this.voceSelezionata.TOTAL_COST_PRIVATO = unitCostPrivato.toFixed(2);
			}
		},

		salvaVoce(continua = false) {
			this.salvandoVoce = true;

			// Validazione: titolo obbligatorio
			if (!this.voceSelezionata.TITOLO_VOCE || this.voceSelezionata.TITOLO_VOCE.trim() == '') {
				utils.alert.warning("Il titolo della voce è obbligatorio");
				this.salvandoVoce = false;
				return;
			}

			// Validazione: quantità e ripetizioni devono essere almeno 1
			if (!this.voceSelezionata.QUANTITY_PRICE || this.voceSelezionata.QUANTITY_PRICE < 1) {
				utils.alert.warning("La quantità (Prezzo) deve essere almeno 1");
				this.salvandoVoce = false;
				return;
			}
			if (!this.voceSelezionata.DAYS_PRICE || this.voceSelezionata.DAYS_PRICE < 1) {
				utils.alert.warning("Le ripetizioni (Prezzo) devono essere almeno 1");
				this.salvandoVoce = false;
				return;
			}
			if (!this.voceSelezionata.QUANTITY_COST_ESPOSTO || this.voceSelezionata.QUANTITY_COST_ESPOSTO < 1) {
				utils.alert.warning("La quantità (Costo Esposto) deve essere almeno 1");
				this.salvandoVoce = false;
				return;
			}
			if (!this.voceSelezionata.DAYS_COST_ESPOSTO || this.voceSelezionata.DAYS_COST_ESPOSTO < 1) {
				utils.alert.warning("Le ripetizioni (Costo Esposto) devono essere almeno 1");
				this.salvandoVoce = false;
				return;
			}

			this.calcolaTotalePrezzo();
			this.calcolaTotaleCostoEsposto();
			this.calcolaTotaleCostoPrivato();

			var isUpdate = this.voceSelezionata.ID_VOCE > 0;
			var api = isUpdate ? "theb/voce/update" : "theb/voce/insert";

			const payload = { ...this.voceSelezionata };
			if (payload.TITOLO_VOCE) {
				payload.TITOLO = payload.TITOLO_VOCE;
			}

			(isUpdate ? utils.put : utils.post)(api, payload, (response) => {
				this.salvandoVoce = false;
				if (response.esito == 0) {
					const msg = this.voceSelezionata.ID_VOCE > 0 ? "aggiornata" : "creata";
					utils.alert.success(`Voce ${msg} con successo.`);
					utils.notifiche.invia(this, this.voceSelezionata.ID_VOCE > 0 ? 'VOCE_MODIFICA' : 'VOCE_CREA', (this.voceSelezionata.ID_VOCE > 0 ? 'ha modificato la voce "' : 'ha creato una nuova voce "') + this.voceSelezionata.TITOLO_VOCE + '"');
					this.getAttivita();

					if (continua) {
						this.voceSelezionata = {
							FK_ID_ATTIVITA: this.voceSelezionata.FK_ID_ATTIVITA,
							FK_ID_PROGETTO: this.voceSelezionata.FK_ID_PROGETTO,
							FLG_CONSUNTIVO: this.voceSelezionata.FLG_CONSUNTIVO,
							ID_VOCE: 0,
							TITOLO_VOCE: '',
							NOTE: '',
							COLORE: '#FFFFFF',
				COLORE_TESTO: null,
							FK_ID_AZIENDA: this.progetto.FK_ID_AZIENDA || null,
							FK_ID_AZIENDA_FORNITORE: null,
							QUANTITY_PRICE: 1,
							DAYS_PRICE: 1,
							QUANTITY_COST_ESPOSTO: 1,
							DAYS_COST_ESPOSTO: 1,
							UNIT_PRICE: 0,
							TOTAL_PRICE: 0,
							FK_ID_IVA_PREZZO: null,
							UNIT_COST_ESPOSTO: 0,
							TOTAL_COST_ESPOSTO: 0,
							FK_ID_IVA_COSTO: null,
							UNIT_COST_PRIVATO: 0,
							TOTAL_COST_PRIVATO: 0,
							FK_ID_IVA_COMMISSIONI: null,
							FLG_DA_CALCOLARE: 1,
							FLG_OMAGGIO_UNIT_PRICE: 0,
							FLG_OMAGGIO_TOTAL_PRICE: 0,
							FLG_OMAGGIO_UNIT_COST_ESPOSTO: 0,
							FLG_OMAGGIO_UNIT_COST_PRIVATO: 0,
							FLG_OMAGGIO_TOTAL_COST_PRIVATO: 0,
							FLG_ESCLUDI_TOTALE_VENDITA: 0,
							FLG_ESCLUDI_FEE_VENDITA: 0,
							FLG_NETTO_IVA_VENDITA: 1,
							FLG_ESCLUDI_TOTALE_ACQUISTO: 0,
							FLG_NETTO_IVA_ACQUISTO: 1,
							FLG_NETTO_IVA_COMMISSIONI: 1,
						};
					} else {
						this.filters.closePopUp("popUpVoce");
					}
				}
			});
		},

		eliminaVoce(voce) {
			utils.alert.confirm('Sei sicuro di voler eliminare questa voce?', () => {
				utils.delete('theb/voce/delete', { ID_VOCE: voce.ID_VOCE }, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Voce eliminata con successo.');
						utils.notifiche.invia(this, 'VOCE_ELIMINA', 'ha eliminato la voce "' + voce.TITOLO_VOCE + '"');
						this.getAttivita();
					}
				});
			}, this.$root);
		},

		eliminaDefinitivamenteVoce(voce) {
			utils.alert.confirm('ATTENZIONE: Eliminare DEFINITIVAMENTE questa voce? Azione irreversibile.', () => {
				utils.delete('theb/voce/harddelete', { ID_VOCE: voce.ID_VOCE }, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Voce eliminata definitivamente.');
						this.getAttivita();
					}
				});
			}, this.$root);
		},

		apriAzioniVoce(payload) {
			const { azione, voce, attivita } = payload;
			this.vocePerAzioni = voce;
			this.attivitaPerAzioniVoce = attivita;

			switch (azione) {
				case 'toggle-attivo':
					voce.FLG_ATTIVO_VOCE = voce.FLG_ATTIVO_VOCE == 1 ? 0 : 1;
					utils.put('theb/voce/update', {
						ID_VOCE: voce.ID_VOCE,
						FLG_ATTIVO: voce.FLG_ATTIVO_VOCE,
						TITOLO: voce.TITOLO_VOCE,
					}, (response) => {
						if (response.esito == 0) {
							this.getAttivita();
						}
					});
					break;
				case 'modifica':
					this.modificaVoce(voce, attivita);
					break;
				case 'consuntivo':
					this.toggleConsuntivo('voce', voce.ID_VOCE, voce.FLG_CONSUNTIVO);
					break;
				case 'storna':
					// la voce resta a preventivo, lo storno la compensa nel consuntivo (importo IVA esclusa)
					this.apriStorni();
					this.storniInModifica = this.storniInModifica.filter(st => st.DESCRIZIONE || st.IMPORTO);
					this.storniInModifica.push({ DESCRIZIONE: voce.TITOLO_VOCE, IMPORTO: Math.abs(parseFloat(voce.TOTAL_PRICE) || 0) });
					break;
				case 'aggiungi-preferito':
					this.vocePreferitaTemp = utils.clone(voce);
					this.vocePreferitaTemp.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
					this.filters.openPopUp("popUpAggiungiVocePreferita");
					break;
				case 'allegati':
					this.voceAllegati = voce;
					break;
				case 'fattura':
					this.voceFattura = voce;
					break;
				case 'elimina':
					this.eliminaVoce(voce);
					break;
				case 'elimina-definitivamente':
					this.eliminaDefinitivamenteVoce(voce);
					break;
				case 'ripristina':
					utils.alert.confirm(`Ripristinare la voce "${voce.TITOLO_VOCE}"?`, () => {
						utils.put('theb/voce/ripristina', { ID_VOCE: voce.ID_VOCE }, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Voce ripristinata.');
								utils.notifiche.invia(this, 'VOCE_MODIFICA', 'ha ripristinato la voce "' + voce.TITOLO_VOCE + '"');
								this.getAttivita();
							}
						});
					}, this.$root);
					break;
			}
		},

		azioneToggleAttivoVoce() {
			this.vocePerAzioni.FLG_ATTIVO_VOCE = this.vocePerAzioni.FLG_ATTIVO_VOCE == 1 ? 0 : 1;
			utils.put('theb/voce/update', {
				ID_VOCE: this.vocePerAzioni.ID_VOCE,
				FLG_ATTIVO: this.vocePerAzioni.FLG_ATTIVO_VOCE,
				TITOLO: this.vocePerAzioni.TITOLO_VOCE,
			}, (response) => {
				if (response.esito == 0) {
					this.filters.closePopUp('popUpAzioniVoci');
					this.getAttivita();
				}
			});
		},

		azioneModificaVoce() {
			this.filters.closePopUp('popUpAzioniVoci');
			this.modificaVoce(this.vocePerAzioni, this.attivitaPerAzioniVoce);
		},

		toggleFornitore(opt) {
			utils.put('theb/azienda/' + (opt.ATTIVO == 1 ? 'disattiva' : 'attiva') + '-bulk', { IDS: [opt.ID_AZIENDA] }, (r) => {
				if (r.esito == 0) opt.ATTIVO = opt.ATTIVO == 1 ? 0 : 1;
			});
		},
		apriNuovoFornitore() {
			this.$refs.schedaAziendaFornitore.openSchedaAzienda({ ID_AZIENDA: 0, personaGiuridica: {} });
		},

		onFornitoreCreato(azienda) {
			this.$refs.schedaAziendaFornitore.chiudi();
			if (azienda?.ID_AZIENDA > 0) {
				this.voceSelezionata.FK_ID_AZIENDA_FORNITORE = azienda.ID_AZIENDA;
			}
		},

		azioneEliminaVoce() {
			this.filters.closePopUp('popUpAzioniVoci');
			this.eliminaVoce(this.vocePerAzioni);
		},
		azioneAggiungiPreferito() { 
			this.vocePreferitaTemp = utils.clone(this.vocePerAzioni); 
			this.vocePreferitaTemp.FK_ID_UTENTE = this.$root.utente.ID_UTENTE; 
			this.filters.closePopUp("popUpAzioniVoci"); 
			this.filters.openPopUp("popUpAggiungiVocePreferita"); 
		},

		apriAzioni(payload) {
			const { azione, attivita } = payload;
			this.attivitaPerAzioni = attivita;

			switch (azione) {
				case 'aggiungi-voce':
					this.creaVoce(attivita);
					break;
				case 'aggiungi-sotto-attivita':
					// dal nodo virtuale nasce un'attivita' radice a consuntivo
					this.creaAttivita(attivita.FLG_VIRTUALE ? { FLG_CONSUNTIVO: 1 } : { FK_ID_ATTIVITA: attivita.ID_ATTIVITA });
					break;
				case 'consuntivo':
					this.toggleConsuntivo('attivita', attivita.ID_ATTIVITA, attivita.FLG_CONSUNTIVO);
					break;
				case 'storni':
					this.apriStorni();
					break;
				case 'importa-voce-preferita':
					this.apriImportaVocePreferita(attivita);
					break;
				case 'modifica':
					this.modificaAttivita(attivita);
					break;
				case 'elimina':
					utils.alert.confirm('Nascondere questa attività e tutti i suoi figli?', () => {
						utils.delete('theb/attivita/delete', {
							ID_ATTIVITA: attivita.ID_ATTIVITA,
							CASCADE: 1
						}, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Attività eliminata con successo.');
								this.getAttivita();
							}
						});
					}, this.$root);
					break;
				case 'elimina-definitivamente':
					utils.alert.confirm('ATTENZIONE: Eliminare DEFINITIVAMENTE questa attività e tutti i suoi figli? Azione irreversibile.', () => {
						utils.delete('theb/attivita/harddelete', {
							ID_ATTIVITA: attivita.ID_ATTIVITA,
							CASCADE: 1
						}, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Attività eliminata definitivamente.');
								this.getAttivita();
							}
						});
					}, this.$root);
					break;
				case 'ripristina':
					utils.alert.confirm(`Ripristinare l'attività "${attivita.TITOLO}" e tutti i suoi figli?`, () => {
						utils.put('theb/attivita/ripristina', {
							ID_ATTIVITA: attivita.ID_ATTIVITA,
							CASCADE: 1
						}, (response) => {
							if (response.esito == 0) {
								utils.alert.success('Attività ripristinata.');
								this.getAttivita();
							}
						});
					}, this.$root);
					break;
			}
		},

		apriAzioniSpesa({ azione, notaSpesa }) {
			switch (azione) {
				case 'modifica':
					this.notaSpesaInEdit = notaSpesa;
					this.showModalNuovaSpesa = true;
					break;
				case 'elimina':
					if (confirm('Sei sicuro di voler eliminare questa nota spesa?')) {
						utils.delete('theb/note_spese/delete', { ID_NOTA_SPESA: notaSpesa.ID_NOTA_SPESA }, (res) => {
							if (res.esito == 0) {
								this.getNoteSpese();
								utils.alert.success('Nota spesa eliminata', 'success');
							} else {
								utils.alert.warning('Errore nell\'eliminazione', 'danger');
							}
						});
					}
					break;
			}
		},

		azioneAggiungiVoce() {
			this.filters.closePopUp('popUpAzioni');
			this.creaVoce(this.attivitaPerAzioni);
		},

		azioneAggiungiSottoAttivita() {
			this.filters.closePopUp('popUpAzioni');
			this.creaAttivita({ FK_ID_ATTIVITA: this.attivitaPerAzioni.ID_ATTIVITA });
		},

		azioneModifica() {
			this.filters.closePopUp('popUpAzioni');
			this.modificaAttivita(this.attivitaPerAzioni);
		},

		azioneElimina() {
			this.filters.closePopUp('popUpAzioni');
			utils.alert.confirm('Nascondere questa attività e tutti i suoi figli?', () => {
				utils.delete('theb/attivita/delete', {
					ID_ATTIVITA: this.attivitaPerAzioni.ID_ATTIVITA,
					CASCADE: 1
				}, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Attività eliminata con successo.');
						this.getAttivita();
					}
				});
			}, this.$root);
		},

		azioneEliminaDefinitivamente() {
			this.filters.closePopUp('popUpAzioni');
			utils.alert.confirm('ATTENZIONE: Eliminare DEFINITIVAMENTE questa attività e tutti i suoi figli? Azione irreversibile.', () => {
				utils.delete('theb/attivita/harddelete', {
					ID_ATTIVITA: this.attivitaPerAzioni.ID_ATTIVITA,
					CASCADE: 1
				}, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Attività eliminata definitivamente.');
						this.getAttivita();
					}
				});
			}, this.$root);
		},

		// Un'attività spuntata con tutto il ramo spuntato basta da sola: le route bulk agiscono sul ramo.
		// Se nel ramo manca una spunta si scende e si prendono i singoli elementi.
		// soloVoci: le attività restano, si prendono tutte le voci spuntate.
		raccogliSelezionati(soloVoci = false) {
			const attivita = new Set(), voci = new Set();
			let vociInAttivita = 0;
			const completo = (a) => a.SELEZIONATO == 1 && (a.VOCI || []).every(v => v.SELEZIONATO == 1) && (a.SOTTO_ATTIVITA || []).every(completo);
			const contaVoci = (a) => (a.VOCI || []).length + (a.SOTTO_ATTIVITA || []).reduce((s, f) => s + contaVoci(f), 0);
			const visita = (listaAttivita, listaVoci) => {
				listaVoci.forEach(v => { if (v.SELEZIONATO == 1) voci.add(v.ID_VOCE); });
				listaAttivita.forEach(a => {
					if (!soloVoci && completo(a)) {
						// le attività a consuntivo compaiono in entrambi gli alberi
						if (!attivita.has(a.ID_ATTIVITA)) vociInAttivita += contaVoci(a);
						attivita.add(a.ID_ATTIVITA);
					} else {
						visita(a.SOTTO_ATTIVITA || [], a.VOCI || []);
					}
				});
			};
			const cons = this.nodoConsuntivo || {};
			visita(this.arrayAttivita.concat(cons.SOTTO_ATTIVITA || []), cons.VOCI || []);
			return { ATTIVITA: [...attivita], VOCI: [...voci], VOCI_IN_ATTIVITA: vociInAttivita };
		},

		// Esegue le chiamate una dopo l'altra, un solo refresh alla fine (anche se una fallisce)
		eseguiInCatena(passi, messaggio) {
			const prossimo = (i) => {
				if (i == passi.length) {
					utils.alert.success(messaggio);
					this.getAttivita();
					return;
				}
				passi[i]((response) => {
					if (response.esito == 0) prossimo(i + 1);
					else this.getAttivita();
				});
			};
			prossimo(0);
		},

		bulkSelezionati(azione, params, domanda, messaggio) {
			const sel = this.raccogliSelezionati();
			const totale = sel.ATTIVITA.length + sel.VOCI.length;
			if (totale == 0) {
				utils.alert.warning('Nessuna attività o voce selezionata.');
				return;
			}
			utils.alert.confirm(domanda + ' ' + totale + ' elementi selezionati?', () => {
				const passi = [];
				if (sel.ATTIVITA.length) passi.push(cb => utils.put('theb/attivita/' + azione, Object.assign({ IDS: sel.ATTIVITA }, params), cb));
				if (sel.VOCI.length) passi.push(cb => utils.put('theb/voce/' + azione, Object.assign({ IDS: sel.VOCI }, params), cb));
				this.eseguiInCatena(passi, messaggio);
			}, this.$root);
		},

		attivaSelezionati() {
			this.bulkSelezionati('attivo-bulk', { FLG_ATTIVO: 1 }, 'Attivare', 'Elementi attivati con successo.');
		},
		disattivaSelezionati() {
			this.bulkSelezionati('attivo-bulk', { FLG_ATTIVO: 0 }, 'Disattivare', 'Elementi disattivati con successo.');
		},
		consuntivoSelezionati(flg) {
			this.bulkSelezionati('consuntivo-bulk', { FLG_CONSUNTIVO: flg }, flg == 1 ? 'Spostare a consuntivo' : 'Riportare a preventivo', 'Operazione completata.');
		},
		ripristinaSelezionati() {
			this.bulkSelezionati('ripristina-bulk', {}, 'Ripristinare', 'Elementi ripristinati con successo.');
		},

		eliminaSelezionati() {
			this.mantieniAttivita = false;
			const r = this.riepilogoElimina;
			if (r.ATTIVITA.length + r.VOCI.length + r.STORNI + r.SCONTI == 0) {
				utils.alert.warning('Nessun elemento selezionato.');
				return;
			}
			this.filters.openPopUp('popUpEliminaSelezionati');
		},

		confermaEliminaSelezionati() {
			const r = this.riepilogoElimina;
			const idProgetto = this.progetto.ID_PROGETTO;
			const passi = [];
			if (r.ATTIVITA.length) passi.push(cb => utils.delete('theb/attivita/delete-bulk', { IDS: r.ATTIVITA }, cb));
			if (r.VOCI.length) passi.push(cb => utils.delete('theb/voce/delete-bulk', { IDS: r.VOCI }, cb));
			// storni e sconti si salvano come lista intera: si rimanda quella senza gli spuntati
			if (r.STORNI) passi.push(cb => utils.put('theb/progetto/storni', { ID_BUDGET: idProgetto, STORNI: this.arrayStorni.filter(s => s.SELEZIONATO != 1) }, cb));
			if (r.SCONTI) passi.push(cb => utils.put('theb/progetto/sconti', { ID_BUDGET: idProgetto, SCONTI: this.arraySconti.filter(s => s.SELEZIONATO != 1) }, cb));
			this.filters.closePopUp('popUpEliminaSelezionati');
			this.eseguiInCatena(passi, 'Elementi eliminati con successo.');
		},

		ordineAttivitaChanged() {
			const attivitaAggiornate = this.paginatedList.arr.map((att, i) => ({
				ID_ATTIVITA: att.ID_ATTIVITA,
				ORDINE: i + 1
			}));
			utils.put("theb/attivita/ordine", {
				array: attivitaAggiornate,
				ID_BUDGET: this.progetto.ID_PROGETTO
			}, (response) => {
				if (response.esito == 0) {
					utils.alert.success("Ordine attività salvato con successo.");
					this.getAttivita();
				}
			});
		},

		onRootAttivitaDragStart(evt) {
			document.body.classList.add('is-dragging');
			const attivita = this.attivitaList[evt.oldIndex];
			this.draggingRootAttivita = {
				type: 'attivita',
				item: attivita,
				sourceParentId: null, // null = root level
				sourceIndex: evt.oldIndex,
			};
		},

		onRootAttivitaDragEnd() {
			document.body.classList.remove('is-dragging');
			this.draggingRootAttivita = null;
		},

		onRootAttivitaMove(evt) {
			// Blocca voci dal root level (solo attività possono stare al root)
			if (evt.draggedContext && evt.draggedContext.element && evt.draggedContext.element.ID_VOCE !== undefined) {
				return false;
			}
			// Permetti il movimento di attività tra drag-list diverse (cross-level, incluso da sotto-attività al root)
			return true;
		},

		async salvaOrdinamento() {
			this.saving = true;

			try {
				// Step 1: Raccogli tutti gli ordini dall'albero corrente
				const allUpdates = this.collectAllOrdersFromTree();

				// Step 2: Chiamate API batch per attività
				if (allUpdates.attivita.length > 0) {
					await new Promise((resolve, reject) => {
						utils.put('theb/attivita/ordine', {
							array: allUpdates.attivita,
							ID_BUDGET: this.progetto.ID_PROGETTO
						}, (response) => {
							if (response.esito == 0) {
								resolve();
							} else {
								reject(new Error("Errore salvataggio attività"));
							}
						});
					});
				}

				// Step 3: Chiamate API batch per voci (raggruppate per attività)
				for (const [idAttivita, voci] of Object.entries(allUpdates.vociByAttivita)) {
					await new Promise((resolve, reject) => {
						utils.put('theb/voce/ordine', {
							array: voci,
							ID_ATTIVITA: parseInt(idAttivita)
						}, (response) => {
							if (response.esito == 0) {
								resolve();
							} else {
								reject(new Error(`Errore salvataggio voci attività ${idAttivita}`));
							}
						});
					});
				}

				// Step 4: Ricarica albero aggiornato dal backend
				await new Promise((resolve) => {
					this.getAttivita();
					this.$nextTick(resolve);
				});

				this.hasUnsavedChanges = false;
				this.editMode = false; // Torna alla modalità normale con filtri
				utils.alert.success("Ordinamento salvato con successo");

			} catch (error) {
				utils.alert.danger("Errore nel salvataggio: " + error.message);
			} finally {
				this.saving = false;
			}
		},

		collectAllOrdersFromTree() {
			const attivita = [];
			const vociByAttivita = {};

			const traverseAttivita = (att, index, parentId = null) => {
				// Raccogli ordine attività E relazione madre-figlia
				attivita.push({
					ID_ATTIVITA: att.ID_ATTIVITA,
					ORDINE: index + 1,
					FK_ID_ATTIVITA: parentId // null per root, ID_ATTIVITA del parent per sotto-attività
				});

				// Raccogli ordine voci di questa attività E relazione con attività
				if (att.VOCI && att.VOCI.length > 0) {
					vociByAttivita[att.ID_ATTIVITA] = att.VOCI.map((v, i) => ({
						ID_VOCE: v.ID_VOCE,
						ORDINE: i + 1,
						FK_ID_ATTIVITA: att.ID_ATTIVITA // Assicura che la voce appartenga a questa attività
					}));
				}

				// Ricorsione su sotto-attività
				if (att.SOTTO_ATTIVITA && att.SOTTO_ATTIVITA.length > 0) {
					att.SOTTO_ATTIVITA.forEach((sub, i) => {
						traverseAttivita(sub, i, att.ID_ATTIVITA); // Passa l'ID del parent
					});
				}
			};

			// Attraversa l'albero root
			this.arrayAttivita.forEach((att, i) => {
				traverseAttivita(att, i, null); // null = root level
			});

			return { attivita, vociByAttivita };
		},

		onRootAttivitaChange(evt) {
			// Aggiorna FK_ID_ATTIVITA per cross-level moves (spostamento a root = null)
			if (evt.added) {
				evt.added.element.FK_ID_ATTIVITA = null;
			}

			// Il drag modifica già arrayAttivita in place (quando editMode = true)
			// Segna solo che ci sono modifiche non salvate
			this.hasUnsavedChanges = true;
		},

		disabilitaRiordino() {
			if (this.hasUnsavedChanges) {
				const conferma = confirm('Hai modifiche non salvate. Vuoi davvero annullare?');
				if (!conferma) return;

				// Ricarica i dati originali dal backend
				this.getAttivita();
			}
			this.editMode = false;
			this.hasUnsavedChanges = false;
		},


		tornaAProgetti() {
			global.router.push('/Progetti');
		},

		esportaBudgetExcel() {
			// Usa la modalità di esportazione salvata nel progetto, default 1005 (Multi-Foglio)
			
			window.open(utils.BASE_API + "theb/report?ID_REPORT=" + idReport + "&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + "&LANG=" + this.$root.currentLang + utils.getSessionToken());
		},

		esportaProgettoExcel: function () {
			var url = utils.BASE_API + "theb/report?ID_REPORT=4&FORMATO=2&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + utils.getSessionToken();
			window.open(url);
		},

		apriModalitaEsportazione: function () {
			this.modalitaEsportazioneSelezionata = '1007';
			this.filters.openPopUp('popUpModalitaEsportazione');
		},

		apriImportaExcelOffline: function () {
			this.showImportAttivitaExcel = true;
		},

		confermaEsportazioneExcel: function () {
			if (!this.modalitaEsportazioneSelezionata) {
				utils.alert.warning('Seleziona una modalità di esportazione');
				return;
			}
			const idReport = this.modalitaEsportazioneSelezionata;
			this.filters.closePopUp('popUpModalitaEsportazione');
			window.open(utils.BASE_API + "theb/report?ID_REPORT=" + idReport + "&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + "&LANG=" + this.$root.currentLang + utils.getSessionToken());
		},

		caricaModalitaEsportazione: function () {
			utils.get('shared/tipologica', { ID_TIPOLOGICA: 59 }, (response) => {
				if (response.esito == 0 && response.data.opzioni) {
					this.arrayModalitaEsportazione = response.data.opzioni;
				}
			});
		},

		esportaBudgetPdf() {
			this.filters.openPopUp('popUpStampaBudget');
		},

		stampeOrdine: function (idReport) {
			window.open(utils.BASE_API + "core/report?ID_REPORT=" + idReport + "&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + utils.getSessionToken());
		},

		apriFlatPopUpAggiungiVocePreferita() {
			this.vocePreferitaTemp = utils.clone(this.voceSelezionata);
			this.vocePreferitaTemp.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			this.filters.openPopUp("popUpAggiungiVocePreferita");
		},

		salvaVocePreferitaConAzienda() {
			this.salvandoVocePreferita = true;
			const payload = { ...this.vocePreferitaTemp, ID_VOCE: 0 }; // ID_VOCE farebbe scattare il lock BUDGET: qui si crea una preferita, non si scrive la voce
			payload.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			payload.FK_ID_AZIENDA = this.progetto.FK_ID_AZIENDA;
			payload.TITOLO = payload.TITOLO_VOCE;
			payload.FLG_ATTIVO = 1;

			utils.post('theb/voci_preferite/insert',payload, (response) => {
				this.salvandoVocePreferita = false;
				if (response.esito == 0) {
					utils.alert.success("Voce preferita salvata con successo (con azienda).");
					this.filters.closePopUp("popUpAggiungiVocePreferita");
					this.filters.closePopUp("popUpVoce");
				} else {
					utils.alert.danger(response.messaggio || "Errore nel salvataggio della voce preferita.");
				}
			});
		},

		salvaVocePreferitaDueVersioni() {
			this.salvandoVocePreferita = true;
			const payload = { ...this.vocePreferitaTemp, ID_VOCE: 0 };
			payload.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			payload.TITOLO = payload.TITOLO_VOCE;

			// Prima versione: CON azienda
			const payloadConAzienda = { ...payload };
			payloadConAzienda.FK_ID_AZIENDA = this.progetto.FK_ID_AZIENDA;
			payloadConAzienda.FLG_ATTIVO = 1;
			// Seconda versione: SENZA azienda
			const payloadSenzaAzienda = { ...payload };
			payloadSenzaAzienda.FK_ID_AZIENDA = null;
			payloadSenzaAzienda.FLG_ATTIVO = 1;

			utils.post('theb/voci_preferite/insert',payloadConAzienda, (response) => {
				if (response.esito == 0) {
					utils.post('theb/voci_preferite/insert',payloadSenzaAzienda, (response2) => {
						this.salvandoVocePreferita = false;
						if (response2.esito == 0) {
							utils.alert.success("Voce preferita salvata in entrambe le versioni (con e senza azienda).");
							this.filters.closePopUp("popUpAggiungiVocePreferita");
							this.filters.closePopUp("popUpVoce");
						} else {
							utils.alert.danger(response2.messaggio || "Errore nel salvataggio della versione senza azienda.");
						}
					});
				} else {
					this.salvandoVocePreferita = false;
					utils.alert.danger(response.messaggio || "Errore nel salvataggio della voce preferita.");
				}
			});
		},

		salvaVocePreferitaSenzaAzienda() {
			this.salvandoVocePreferita = true;
			const payload = { ...this.vocePreferitaTemp, ID_VOCE: 0 };
			payload.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			payload.FK_ID_AZIENDA = null;
			payload.TITOLO = payload.TITOLO_VOCE;
			payload.FLG_ATTIVO = 1;

			utils.post('theb/voci_preferite/insert',payload, (response) => {
				this.salvandoVocePreferita = false;
				if (response.esito == 0) {
					utils.alert.success("Voce preferita salvata con successo (senza azienda).");
					this.filters.closePopUp("popUpAggiungiVocePreferita");
					this.filters.closePopUp("popUpVoce");
				} else {
					utils.alert.danger(response.messaggio || "Errore nel salvataggio della voce preferita.");
				}
			});
		},

	},

	computed: {

		// URL di stampa del budget senza ID_TEMPLATE: lo aggiunge ReportTemplateModal
		urlStampaBudget() {
			return "theb/report?ID_REPORT=1006&FK_ID_PROGETTO=" + this.$root.progetto.ID_PROGETTO + "&LANG=" + this.$root.currentLang;
		},

		// ==== GESTIONE PERMESSI ====

		canCreateAttivita() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('ATTIVITA_CREATE');
		},

		canEditAttivita() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('ATTIVITA_UPDATE');
		},

		canDeleteAttivita() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('ATTIVITA_DELETE');
		},
		// Tutto ciò che la spunta dell'header seleziona: albero preventivo, contenuto del consuntivo, storni e sconti
		nodiSelezionabili() {
			const cons = this.nodoConsuntivo || {};
			const extra = this.canEditProgetto ? this.arrayStorni.concat(this.arraySconti) : [];
			return this.arrayAttivita.concat(cons.SOTTO_ATTIVITA || [], cons.VOCI || [], extra);
		},
		eliminatiSelezionati() {
			const cerca = (lista, voci) => voci.some(v => v.SELEZIONATO == 1 && v.FLG_ELIMINATO == 1) || lista.some(a => (a.SELEZIONATO == 1 && a.FLG_ELIMINATO == 1) || cerca(a.SOTTO_ATTIVITA || [], a.VOCI || []));
			const cons = this.nodoConsuntivo || {};
			return cerca(this.arrayAttivita.concat(cons.SOTTO_ATTIVITA || []), cons.VOCI || []);
		},

		riepilogoElimina() {
			const r = this.raccogliSelezionati(this.mantieniAttivita);
			r.STORNI = this.arrayStorni.filter(s => s.SELEZIONATO == 1).length;
			r.SCONTI = this.arraySconti.filter(s => s.SELEZIONATO == 1).length;
			return r;
		},

		canExportAttivita() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('ATTIVITA_EXPORT');
		},

		canImportAttivita() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('ATTIVITA_IMPORT');
		},

		canCreateVoce() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('VOCE_CREATE');
		},

		canEditVoce() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('VOCE_UPDATE');
		},

		canEditProgetto() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('PROGETTO_UPDATE');
		},

		canCreateVociPreferite() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('VOCI_PREFERITE_CREATE');
		},

		// ==== FINE GESTIONE PERMESSI ====

		isStorico() {
			return this.revisioneVisualizzata && this.revisioneCorrente && this.revisioneVisualizzata.ID_REVISIONE != this.revisioneCorrente.ID_REVISIONE;
		},
		bloccato() { return this.lock != null && !this.lock.MIO; },
		isReadOnly() { return this.isStorico || this.bloccato; },

		paginatedList() {
			return global.utils.inGridRicorsiva(this.alberoFiltrato, this.search, this.ordinamento, 'VOCI');
		},
		alberoFiltrato() {
			return this.filtroFornitore > 0 ? this.filtraPerFornitore(this.arrayAttivita, true) : this.arrayAttivita;
		},
		consuntivoFiltrato() {
			if (!this.nodoConsuntivo) return null;
			const nodo = this.filtroFornitore > 0 ? this.filtraPerFornitore([this.nodoConsuntivo], false)[0] : Object.assign({}, this.nodoConsuntivo);
			nodo.STORNI = this.storniAttivi;
			return nodo;
		},
		scontiAttivi() {
			return this.mostraSconti == '1' ? this.arraySconti : [];
		},
		storniAttivi() {
			return this.mostraStorni == '1' ? this.arrayStorni : [];
		},
		// Fornitori delle voci del progetto: opzioni mostrate all'apertura del filtro, prima di cercare
		fornitoriProgetto() {
			const visti = {};
			const voci = this.attivitaFlat.concat(this.nodoConsuntivo ? [this.nodoConsuntivo] : []).flatMap(a => a.VOCI || []);
			voci.forEach(v => {
				if (v.FK_ID_AZIENDA_FORNITORE > 0) visti[v.FK_ID_AZIENDA_FORNITORE] = { id: v.FK_ID_AZIENDA_FORNITORE, text: v.FORNITORE_ALIAS };
			});
			return utils.array.ordinaArray(Object.values(visti), 'text');
		},
		paginatedListStorico() {
			var arr =  global.utils.inGrid(this.revisioni,this.searchStorico);
			return arr;
		},

		paginatedVociPreferiteImport() {
			return global.utils.inGrid(this.vociPreferitePerImport, this.searchVocePreferitaImport);
		},

		idAttivitaSelezionateCorrente() {
			return this.attivitaSelezionatePerImport
				.filter(a => a.ID_REVISIONE == this.revisioneSelezionataPerImport)
				.map(a => a.ID_ATTIVITA);
		},

		basketCountsByRevision() {
			const counts = {};
			this.revisioniPerImport.forEach(rev => {
				counts[rev.ID_REVISIONE] = this.attivitaSelezionatePerImport
					.filter(a => a.ID_REVISIONE == rev.ID_REVISIONE).length;
			});
			return counts;
		},

		selectAllAttivitaImport() {
			return this.attivitaPerImport.length > 0
				&& this.attivitaPerImport.every(a => this.idAttivitaSelezionateCorrente.includes(a.ID_ATTIVITA));
		},

		// Array da usare per il draggable e il v-for
		// In editMode: usa arrayAttivita (no filtri, drag attivo)
		// In modalità normale: usa paginatedList.arr (filtri attivi, drag disabilitato)
		attivitaList() {
			return this.editMode ? this.arrayAttivita : this.paginatedList.arr;
		},

		attivitaFlat() {
			var risultato = [];
			this.flattenAttivita(this.arrayAttivita, risultato);
			return risultato;
		},

		idDiscendentiSelezionata() {
			var risultato = [];
			this.flattenAttivita(this.attivitaSelezionata.SOTTO_ATTIVITA || [], risultato);
			return risultato.map(att => att.ID_ATTIVITA);
		},

		coloreTestoAutomaticoAttivita: {
			get() {
				return !this.attivitaSelezionata.COLORE_TESTO;
			},
			set(val) {
				this.attivitaSelezionata.COLORE_TESTO = val ? null : (this.utils.getContrastColor(this.attivitaSelezionata.COLORE) || '#000000');
			},
		},

		coloreTestoAutomaticoVoce: {
			get() {
				return !this.voceSelezionata.COLORE_TESTO;
			},
			set(val) {
				this.voceSelezionata.COLORE_TESTO = val ? null : (this.utils.getContrastColor(this.voceSelezionata.COLORE) || '#000000');
			},
		},

		ivaModaleSommario() {
			const prezzo = parseFloat(this.voceSelezionata.TOTAL_PRICE) || 0;
			if (this.voceSelezionata.FLG_NETTO_IVA_VENDITA == 1) {
				return { aliquota: 0, importo: '0.00', totale: this.voceSelezionata.ID_VOCE > 0 ? prezzo.toFixed(2) : '' };
			}
			const codiceIva = this.filters.getIvaCodeById(this.voceSelezionata.FK_ID_IVA_PREZZO);
			const { aliquota, tipo } = this.filters.parseCodiceIva(codiceIva);
			const importo = this.filters.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo == 'esclusa' ? prezzo + importo : prezzo;
			return {
				aliquota,
				importo: importo.toFixed(2),
				totale: totale.toFixed(2),
			};
		},

		ivaAcquistoSommario() {
			const prezzo = parseFloat(this.voceSelezionata.TOTAL_COST_ESPOSTO) || 0;
			if (this.voceSelezionata.FLG_NETTO_IVA_ACQUISTO == 1) {
				return { aliquota: 0, importo: '0.00', totale: this.voceSelezionata.ID_VOCE > 0 ? prezzo.toFixed(2) : '' };
			}
			const codiceIva = this.filters.getIvaCodeById(this.voceSelezionata.FK_ID_IVA_COSTO);
			const { aliquota, tipo } = this.filters.parseCodiceIva(codiceIva);
			const importo = this.filters.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo == 'esclusa' ? prezzo + importo : prezzo;
			return {
				aliquota,
				importo: importo.toFixed(2),
				totale: totale.toFixed(2),
			};
		},

		ivaCommissioniSommario() {
			const prezzo = parseFloat(this.voceSelezionata.TOTAL_COST_PRIVATO) || 0;
			if (this.voceSelezionata.FLG_NETTO_IVA_COMMISSIONI == 1) {
				return { aliquota: 0, importo: '0.00', totale: this.voceSelezionata.ID_VOCE > 0 ? prezzo.toFixed(2) : '' };
			}
			const codiceIva = this.filters.getIvaCodeById(this.voceSelezionata.FK_ID_IVA_COMMISSIONI);
			const { aliquota, tipo } = this.filters.parseCodiceIva(codiceIva);
			const importo = this.filters.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo == 'esclusa' ? prezzo + importo : prezzo;
			return {
				aliquota,
				importo: importo.toFixed(2),
				totale: totale.toFixed(2),
			};
		},

		// Configurazioni Personali > TOTALI ATTIVITA: FONDO (default, badge sotto la tabella) o ALBERO (righe in coda a preventivo e consuntivo)
		totaliInAlbero() {
			return this.filters.getCustomOpzione('TOTALI ATTIVITA') == 'ALBERO';
		},

		// Blocchi in coda all'albero: preventivo (sconti ed eventuali totali) e nodo consuntivo (con eventuali totali)
		sezioniAlbero() {
			var t = this.getTotali;
			var tr = (chiave) => this.$root.translate('dizionario.attivita.' + chiave);
			// stessi colori dei badge dei totali in fondo alla pagina
			var riga = (label, valore, colore) => ({ LABEL: label, VALORE: valore, CLASSE: 'fw-semibold ' + colore });
			var SECONDARY = 'bg-secondary bg-opacity-20 text-secondary', INFO = 'bg-info bg-opacity-20 text-info', PRIMARY = 'bg-primary bg-opacity-20 text-primary', PIENO = 'bg-primary text-white';
			var fee = tr('FEE_AGENZIA') + ' ' + (this.progetto.FEE || 0) + '%';

			var apriSconti = !this.isReadOnly && this.$root.hasFunzionalita('PROGETTO_UPDATE') ? this.apriSconti : null;
			var sconti = this.scontiAttivi.map(sc => ({ REF: sc, LABEL: sc.DESCRIZIONE, VALORE: sc.IMPORTO, NEGATIVO: 1, CLASSE: 'fw-semibold bg-secondary bg-opacity-20 text-secondary', CLICK: apriSconti }));

			var preventivo = sconti;
			if (this.totaliInAlbero) {
				preventivo = [riga(tr('TOTALE_PARZIALE'), t.BUDGET, SECONDARY), riga(fee, t.FEE, INFO), riga(tr('TOTALE_IMPONIBILE'), t.GRAND_TOTAL, PRIMARY)].concat(sconti);
				if (t.SCONTO > 0) preventivo.push(riga(tr('TOTALE_GENERALE'), t.TOTALE_GENERALE, PIENO));
				// acquisto, commissioni, margine e utile sempre sulle ultime 4 righe del preventivo (riga vuota se ne mancano)
				if (preventivo.length < 4) preventivo.push({ VUOTA: 1 });
				var n = preventivo.length;
				var iva = this.showIva;
				var SUCCESS = 'fw-semibold bg-success bg-opacity-20 text-success';
				preventivo[n - 4].ACQ = { LABEL: tr('ACQUISTO'), VALORE: iva && t.TOTALE_IVA_COSTO > 0 ? t.TOTALE_CON_IVA_COSTO : t.COSTO_ESPOSTO, CLASSE: 'fw-semibold bg-danger bg-opacity-20 text-danger', TITLE: this.getPct(t.COSTO_ESPOSTO) };
				preventivo[n - 3].ACQ = { LABEL: tr('COMMISSIONI'), VALORE: iva && t.TOTALE_IVA_COMMISSIONI > 0 ? t.TOTALE_CON_IVA_COMMISSIONI : t.COSTO_PRIVATO, CLASSE: 'fw-semibold bg-warning bg-opacity-20 text-warning', TITLE: this.getPct(t.COSTO_PRIVATO) };
				preventivo[n - 2].ACQ = { LABEL: tr('MARGINE'), VALORE: t.MARGINE, CLASSE: SUCCESS, TITLE: this.getMarginePercentage() + '% del budget' };
				preventivo[n - 1].ACQ = { LABEL: tr('UTILE'), PCT: this.getMarginePercentage(), CLASSE: SUCCESS };
			}
			var sezioni = [{ KEY: 'preventivo', RIGHE: preventivo }];
			if (!this.consuntivoFiltrato) return sezioni;

			var consuntivo = [];
			if (this.totaliInAlbero) {
				consuntivo = [riga(tr('TOTALE_PARZIALE'), t.CONS_BUDGET, SECONDARY), riga(fee, t.CONS_FEE, INFO), riga(tr('TOTALE_IMPONIBILE'), t.CONS_IMPONIBILE, PRIMARY)];
				if (t.STORNI != 0) {
					consuntivo.push({ LABEL: tr('STORNI'), VALORE: t.STORNI, CLASSE: 'fw-semibold bg-danger bg-opacity-20 text-danger', CLICK: this.bloccato ? null : this.apriStorni });
					consuntivo.push(riga(tr('TOTALE_IMPONIBILE'), t.CONS_IMPONIBILE_2, PRIMARY));
				}
				consuntivo.push(riga(tr('TOTALE_FINALE'), t.TOTALE_FINALE, PIENO));
			}
			sezioni.push({ KEY: 'consuntivo', NODO: this.consuntivoFiltrato, RIGHE: consuntivo });
			return sezioni;
		},

		getTotali() {
			var attivita = 0;
			var voci = 0;
			var budget = 0;
			var budgetFee = 0;
			var costoEsposto = 0;
			var costoPrivato = 0;

			var sommaRicorsiva = (nodi) => {
				for (var i = 0; i < nodi.length; i++) {
					var nodo = nodi[i];
					if (nodo.FLG_ATTIVO == 1) attivita++;
					if (nodo.VOCI) {
						for (var v = 0; v < nodo.VOCI.length; v++) {
							var voce = nodo.VOCI[v];
							if (voce.FLG_ATTIVO_VOCE == 1 && voce.FLG_DA_CALCOLARE == 1) {
								voci++;
							}
						}
					}
					if (nodo.SOTTO_ATTIVITA && nodo.SOTTO_ATTIVITA.length > 0) {
						sommaRicorsiva(nodo.SOTTO_ATTIVITA);
					}
				}
			};

			sommaRicorsiva(this.alberoFiltrato);

			// IVA: la vendita e' quella del preventivo, i costi comprendono anche il consuntivo
			const ivaPrev = this.filters.sommaIvaVoci(this.alberoFiltrato, true);
			const ivaCons = this.filters.sommaIvaVoci(this.consuntivoFiltrato ? [this.consuntivoFiltrato] : []);
			const totaleIva = ivaPrev.totaleIva;
			const totaleIvaCosto = ivaPrev.totaleIvaCosto + ivaCons.totaleIvaCosto;
			const totaleIvaCommissioni = ivaPrev.totaleIvaCommissioni + ivaCons.totaleIvaCommissioni;

			// Somma i subtotali già calcolati dal backend per le attività root
			for (var i = 0; i < this.alberoFiltrato.length; i++) {
				var att = this.alberoFiltrato[i];
				// una root a consuntivo si vede nell'albero ma si somma nel nodo Consuntivo
				if (att.FLG_ATTIVO == 1 && att.FLG_CONSUNTIVO != 1) {
					budget += parseFloat(att.SUBTOTALE_BUDGET) || 0;
					budgetFee += parseFloat(att.SUBTOTALE_BUDGET_FEE) || 0;
					costoEsposto += parseFloat(att.SUBTOTALE_ESPOSTO) || 0;
					costoPrivato += parseFloat(att.SUBTOTALE_PRIVATO) || 0;
				}
			}

			// Note spese associate al progetto: solo addebiti (TIPO_MOVIMENTO == 0) sono un costo
			for (var ns = 0; ns < this.arrayNoteSpese.length; ns++) {
				if (this.arrayNoteSpese[ns].TIPO_MOVIMENTO == 0) {
					costoEsposto += parseFloat(this.arrayNoteSpese[ns].IMPORTO) || 0;
				}
			}

			// Consuntivo: subtotali del nodo virtuale; i costi entrano nell'acquisto/commissioni del progetto
			var cons = this.consuntivoFiltrato || {};
			var consBudget = parseFloat(cons.SUBTOTALE_BUDGET) || 0;
			var consBudgetFee = parseFloat(cons.SUBTOTALE_BUDGET_FEE) || 0;
			costoEsposto += parseFloat(cons.SUBTOTALE_ESPOSTO) || 0;
			costoPrivato += parseFloat(cons.SUBTOTALE_PRIVATO) || 0;

			// Stesse formule di Progetto::calcolaTotaliEconomici (report 1006/1007).
			// FEE di progetto: percentuale unica applicata al budget totale (al netto delle voci escluse da FLG_ESCLUDI_FEE_VENDITA),
			// prima di sconto e storni. Lo sconto vale solo per il preventivo, sugli storni non c'e' fee.
			var percFee = parseFloat(this.progetto.FEE) || 0;
			var fee = budgetFee * percFee / 100;
			var sconto = utils.array.sumByField(this.scontiAttivi, 'IMPORTO');
			var totaleGenerale = budget + fee - sconto;
			var consFee = consBudgetFee * percFee / 100;
			var storni = utils.array.sumByField(this.storniAttivi, 'IMPORTO');
			var consImponibile2 = consBudget + consFee + storni;
			var totaleFinale = totaleGenerale + consImponibile2;

			return {
				ATTIVITA: attivita,
				VOCI: voci,
				BUDGET: budget.toFixed(2),
				COSTO_ESPOSTO: costoEsposto.toFixed(2),
				COSTO_PRIVATO: costoPrivato.toFixed(2),
				TOTALE_IVA: totaleIva.toFixed(2),
				TOTALE_CON_IVA: (budget + totaleIva).toFixed(2),
				TOTALE_IVA_COSTO: totaleIvaCosto.toFixed(2),
				TOTALE_CON_IVA_COSTO: (costoEsposto + totaleIvaCosto).toFixed(2),
				TOTALE_IVA_COMMISSIONI: totaleIvaCommissioni.toFixed(2),
				TOTALE_CON_IVA_COMMISSIONI: (costoPrivato + totaleIvaCommissioni).toFixed(2),
				FEE: fee.toFixed(2),
				GRAND_TOTAL: (budget + fee).toFixed(2),
				SCONTO: sconto.toFixed(2),
				TOTALE_GENERALE: totaleGenerale.toFixed(2),
				CONS_BUDGET: consBudget.toFixed(2),
				CONS_FEE: consFee.toFixed(2),
				CONS_IMPONIBILE: (consBudget + consFee).toFixed(2),
				STORNI: storni.toFixed(2),
				CONS_IMPONIBILE_2: consImponibile2.toFixed(2),
				TOTALE_FINALE: totaleFinale.toFixed(2),
				MARGINE: (totaleFinale + costoPrivato - costoEsposto).toFixed(2),
			}
		},

	},

	created: function () {
		global.utils.BASE_API = process.env.VUE_APP_API_URL;
		this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
		this.caricaModalitaEsportazione();
		this.getAttivita();
		this.caricaRevisioni();
		this.getNoteSpese();
		this.lockHandle = utils.lock.acquire('BUDGET', this.$root.progetto.ID_PROGETTO, (stato) => this.lock = stato, () => this.getAttivita());
	},

	beforeUnmount() {
		utils.lock.release(this.lockHandle);
	}


}
</script>

<style scoped>
	/* popUpVoce: Costo un po' più largo della col-md-1 (non va a capo), select IVA un po' più stretta della col-md-2 */
	@media (min-width: 768px){.col-costo-voce{flex:0 0 auto;width:11.5%}.col-iva-voce{flex:0 0 auto;width:13.5%}}
	body.is-dragging,body.is-dragging *{user-select: none !important;-webkit-user-select: none !important;-moz-user-select: none !important;-ms-user-select: none !important}
	.thead-bordered th{border: 1px solid #dee2e6}
	.ghost-item{opacity: 0 !important;visibility: hidden}
	.chosen-item{opacity: 0.8;background: #e3f2fd;border: 2px dashed #2196f3 !important}
	/* totali nell'albero: celle vuote del lato acquisto senza bordo */
	.cella-senza-bordo{border-color: white !important}
	.root-attivita-container{min-height: 20px;transition: all 0.2s ease}
	.root-attivita-container.root-attivita-empty{min-height: 80px;background: rgba(33, 150, 243, 0.03);border: 2px dashed rgba(33, 150, 243, 0.3);border-radius: 8px;margin: 8px}
	.root-drop-placeholder{display: flex;align-items: center;justify-content: center;padding: 24px;color: #999;font-size: 0.85rem;font-weight: 400;opacity: 0.7;user-select: none;pointer-events: none}
	.dragging-item{opacity: 0.8;transform: rotate(2deg);cursor: grabbing !important}
	.table-responsive{overflow: visible !important}
	.div_table_resp.tableFixHead,#tableFixHead{overflow-y: auto !important}
	.dropdown-menu{z-index: 9999 !important}
	td{overflow: visible !important}
	tr{overflow: visible !important}
	.dropdown-menu{z-index: 99999 !important;position: absolute !important}
	.table tbody,.table tr,.table td,.table th{overflow: visible !important;position: static !important}
	.table thead{overflow: visible !important}	#tableFixHead .dropdown-menu{position: fixed !important}
	.empty-attivita-placeholder{display: flex;align-items: center;justify-content: center;padding: 24px;color: #adb5bd;font-size: 0.85rem;font-weight: 400;border: 2px dashed #dee2e6;border-radius: 6px;background-color: #f8f9fa;margin: 6px;user-select: none;pointer-events: none}

	/* Il CSS va inserito qui dentro, fuori da editorConfig */
	:deep(.ck-editor__editable) {
	min-height: 10rem; /* Altezza minima dell'area di scrittura */
	max-height: 10rem; /* Altezza massima con scorrimento automatico */
	}
</style>


